const TRANSLATION = {
  buyModal: {
    afterFree: 'మీ ఉచిత ట్రయల్ తర్వాత',
    btn: 'ఇది ఉచితంగా ప్రయత్నించండి',
    freeTrial: '3 రోజుల ఉచిత ప్రయోగం',
    monthLabel: 'మాసం',
    selectLabel: 'ఒక ప్లాన్‌ను ఎంచుకోండి',
    title: 'సబ్స్క్రిప్షన్ ప్లాన్',
    yearLabel: 'సంవత్సరం',
  },
  contact: {
    block1:
      'కస్టమైజేషన్, ప్రశ్నలు లేదా సూచనల కోసం, దయచేసి contact@noam.tools వద్ద మమ్మల్ని సంప్రదించండి. మేము త్వరగా ప్రతిస్పందిస్తాము.',
    block2:
      'గూగుల్ యాప్స్ ఎక్స్టెన్షన్ స్టోర్‌లో ★★★★★ ద్వారా మమ్మల్ని రేటింగ్ આપడం ద్వారా మమ్మల్ని మద్దతు చేయండి.',
    block3: 'ఈ విస్తరణను పంచుకోవడం ద్వారా ఇతరులకు సహాయం చేయండి:',
    title: 'మమ్మల్ని సంప్రదించండి',
  },
  help: {
    AquickOverviewOfNoam: 'నోమ్ యొక్క స్విచ్ఛ సంభాషణ',
    ChatPDF: 'చాట్ పిడిఎఫ్',
    ChatPDF2: 'చాట్‌పిడిఎఫ్',
    FavoritesManagement: 'ప్రియమైనవి నిర్వహణ',
    Fixedplugin: 'ఫిక్సਡ్ ప్లగిన్',
    Focusing: 'ధ్యానం కేంద్రీకరించడం',
    Free: 'ఉచితం',
    FreeTrialBenefits: 'ఫ్రీ ట్రయల్ ప్రయోజనాలు',
    GoWithWikipedia: 'వికీపీడియాతో వెళ్ళండి',
    GoWithYouTube: 'యూట్యూబ్‌తో వెళ్ళండి',
    HoverTranslation: 'హోవర్ అనువాదం',
    Howtouse: 'వాడటం ఎలా',
    ImageTranslation: 'ఇమేజ్ అనువాదం',
    InstantTranslation: 'తక్షణ అనువాదం',
    Membership: 'సభ్యత్వం',
    NoamHelp: 'నోమ్ మీకు అనువదনం మరియు సారాంశం చేయడానికి సహాయపడుతుంది',
    PDFparallelTranslation: 'PDF సమాంతర అనువాదం',
    ParallelTranslation: 'పారలెల్ అనువాదం',
    SkipAllSteps: 'అన్ని దశలను మిస్ చేయండి',
    Summary: 'సారాంశం',
    Translation: 'అనువాదం',
    TryItForFree: 'ఇది ఉచితంగా ప్రయత్నించండి',
    Video: 'వీడియో',
    VideoSummary: 'వీడియో సారాంశం',
    VideoTranslation: 'వీడియో అనువాదం',
    WebSummary: 'వెబ్ సారాంశం',
    WordSelectionTranslation: 'శబ్ద ఎంపిక అనువాదం',
    benefits: 'మీకు వేచి ఉన్న ప్రయోజనాలు మాకు ఉన్నాయి!',
    dayFree: '3 రోజుల ఉచిత ప్రయత్నం',
    done: 'పూర్తయింది',
    next: 'తరువాత',
    pin: 'సులభంగా ప్రాప్యత కోసం నోమ్‌ను పిన్ చేయండి～～',
    planIsNotExist: 'ప్లాన్ అందుబాటులో లేదు',
    startWiki: 'వికิมీడియాతో ప్రారంభం చేద్దాం!',
    startYoutube: 'యూట్యూబ్‌తో ప్రారంభిద్దాం!',
    try: 'తిరిగి ప్రయత్నించండి',
    tryNow: 'ఇప్పుడే ప్రయత్నించండి!',
  },
  home: {
    PDFTranslate: {
      desc: 'ద్విభాషా అనువాదం + చాట్ పిడిఎఫ్',
      sub1: {
        desc: 'ద్విభాషా ప్రదానం మඟිනే మీరు మూలపత్రం మరియు అనువాదాన్ని పక్షపక్షంగా పోల్చవచ్చు, ప్రదాన సామర్థ్యాన్ని మెరుగుపరుస్తుంది.',
        title: 'ద్వభాషా పठనం',
      },
      sub2: {
        desc: 'AI విశ్లేషణ మరియు సారాంశం చేస్తుంది మరియు PDF కంటెంట్‌ను ఆధారంగా మీ ప్రశ్నలకు సమాధానం ఇవ్వగలదు.',
        title: 'చాట్ పిడిఎఫ్',
      },
      sub3: {
        desc: 'ఉயർന്ന ఖచ్చితత్వం మరియు సామర్థ్యం కోసం AI-సమర్థిత PDF అనువాదం.',
        title: 'ఖచ్చితత్వం మరియు సమర్థత',
      },
      title: 'PDF అనువాదం',
    },
    aiAssistant: {
      desc: 'వెబ్ అనువాదాన్ని తెలివిగా మరియు సులభంగా చేయడం',
      panel1: {
        desc: 'ద్విభాషా క్రాస్-రిఫరెన్సింగ్ అనువాదాలు మీరు మూల పాఠాన్ని అనువాదంతో పోల్చడానికి సహాయపడతాయి, తద్వారా మీరు మెరుగ్గా అర్థం చేసుకోవచ్చు మరియు మీ పఠన సామర్థ్యాన్ని మెరుగుపరచవచ్చు.',
        title: 'బైలింగ్వల్ ట్రాన్స్లేషన్',
      },
      panel2: {
        left: {
          desc: 'వెబ్ పేజీని బ్రౌజ్ చేసేటప్పుడు, మీరు అనువదించాల్సిన కంటెంట్‌పై హోవర్ చేసి అనువాదాన్ని చూడலாமు.',
          title: 'హోవర్ అనువాదం',
        },
        right: {
          desc: 'ఒక వెబ్ పేజీని బ్రౌజ్ చేసేటప్పుడు, అనువాదాన్ని చూడటానికి మీరు అనువదించాలనుకునే టెక్స్ట్‌ను ఎంచుకోండి.',
          title: 'టెక్స్ట్ సెలెక్షన్ ట్రాన్స్లేషన్',
        },
      },
      panel3: {
        one: {
          desc: 'ఏప్పుడైనా、ఎక్కడైనా వెబ్ పేజీలు మరియు వీడియో కంటెంట్‌ను అనువదించండి మరియు సమ్మారైజ్ చేయండి、సమృద్ధమైన అనుభవం కోసం!',
          title: 'పాయింట్ మరియు క్లిక్',
        },
        three: {
          desc: 'AI-చే నడిపించే పెద్ద భాషా మోడల్ మెరుగైన ప్రచార అనుభవానికి అనువాద ఖచ్చితత్వం మరియు స్థిరత్వాన్ని నిర్ధారిస్తుంది.',
          title: 'AI-సమగ్ర ప్రేరిత',
        },
        two: {
          desc: 'బహుభాషా పూర్తి కవరేజ్, ద్విభాషా అవరోధ లేని రీడింగ్, వన్-క్లిక్ అనువాదం - వ్యత్యాసాన్ని అనుభవించండి!',
          title: 'మరింత విస్తృత మరియు సులభమైన',
        },
      },
      panel4: {
        tab1: {
          desc: 'మీ సామర్థ్య నిపుణుడు - ChatGPT ను ఉపయోగించి నోమ్ YouTube వీడియో కంటెంట్‌ను అనువదిస్తాడు మరియు సారాంశిస్తాడు మీ సమయాన్ని సేవ్ చేస్తాడు!',
          key: 'వీడియో',
          title: 'వీడియో అనువాదం & సారాంశం',
        },
        tab2: {
          desc: 'వెబ్‌ను బ్రౌజ్ చేస్తున్నప్పుడు చిత్రాలను అనువదించడానికి క్లిక్ చేయండి.',
          key: 'ఇమేజ్',
          title: 'ఇమేజ్ ట్రాన్స్‌లేట్',
        },
        tab3: {
          desc: 'వెబ్ పేజీల నుండి కీలక సమాచారాన్ని తక్షణంగా సేకరిస్తుంది మరియు సారాంశాన్ని అందిస్తుంది, మీ పठన సామర్థ్యాన్ని పెంచుతుంది.',
          key: 'వెబ్',
          title: 'వెబ్ ట్రాన్స్లేట్ & సమ్మరీ',
        },
        tag1: 'సింపుల్',
        tag2: 'సమర్థవంతమైన',
        tag3: 'సులభంగా అర్థం చేసుకోవచ్చు',
      },
      title: 'AI సాయకుడు',
    },
    getStart: 'ప్రారంభించు',
    getStartedForFree: 'ఉచితంగా ప్రారంభించండి',
    howItWork: {
      desc: 'నోమ్ AI మోడళ్‌లను ஒருங்கிணைத்து, క్రాస్-లాంగ్వేజ్ వెబ్ పేజీ అనువాదం మరియు సారాంశీకరణ, PDF మరియు ఇమేజ్ అనువాదం, వీడియో అనువాదం మరియు సారాంశీకరణ కోసం వినియోగదారులకు తెలివైన అనుభవాన్ని అందిస్తుంది',
      title: 'ఇది ఎలా పనిచేస్తుంది',
    },
    lastBlock: { desc: 'సమృద్ధ చదువు అనుభవానికి మెరుగైన AI అనువాదం' },
    top: {
      desc: 'నోమ్ ఒక ఉచిత AI బ్రౌజర్ ఎక్స్‌టెన్షన్ ஆகும், ఇది వెబ్‌పేజీలు, వీడియోలు మరియు PDF కంటెంట్‌ను అనువదಿಸಲು మరియు సంగ్రహించడానికి మీకు సహాయపడుతుంది.\n      నోమ్‌తో చేరండి మరియు మ్యాజిక్‌ను అనుభవించండి!',
      title1: 'ఒక మాజిక్',
      title2: 'ఒక క్లిక్',
    },
    userReviews: {
      desc: 'క్రోమ్ వెబ్ స్టోర్‌లో ఐదు స్టార్ రివ్యూలు',
      title: 'వినియోగదారు విమర్శలు',
    },
  },
  installTips: {
    btn: 'ఇప్పుడే ప్రయత్నించండి',
    text: 'మరింత లక్షణాలను అన్‌లాక్ చేయడానికి "నోమ్ బ్రౌజర్ ప్లగిన్"ను ఇన్‌స్టాల్ చేయండి! వెబ్ క్రాస్-రిఫరెన్సింగ్, వెబ్ వీడియో సమ్మరైజేషన్ మరియు ఇంకా చాలా మieleు!',
  },
  locale: {
    af: 'ఆఫ్రికాన్స్',
    am: 'అమరిక్',
    ar: 'అరబిక్',
    as: 'అస్సామీ',
    auto: 'ఆటో డిటెక్ట్',
    az: 'അസെർബൈജാനി',
    ba: 'బాష్కిర్',
    bg: 'బల్గేరియన్',
    bn: 'బంగ్లా',
    bo: 'టిబెటన్',
    bs: 'బోస్నియన్',
    ca: 'కతలాన్',
    cs: 'చెక్',
    cy: 'వెల్ష్',
    da: 'డేనిష్',
    de: 'జర్మన్',
    dsb: 'లోవర్ సోర్బియన్',
    dv: 'ડિવેહી',
    el: 'గ్రీకు',
    en: 'ఇంగ్లీష్',
    es: 'స్పానిష్',
    et: 'எஸ்டோனியன்',
    eu: 'బాస్క్',
    fa: 'ఫార్సీ',
    fi: 'ఫిన్నిష్',
    fil: 'ఫిలిపీనో',
    fj: 'ఫిజియన్',
    fr: 'ఫ్రెంచ్',
    frCA: 'ఫ్రెంచ్ (కెనడా)',
    ga: 'ఐరిష్',
    gl: 'గలిసియన్',
    gom: 'కొంకణీ',
    gu: 'గుజరాతీ',
    ha: 'హౌసా',
    he: 'హీబ్రూ',
    hi: 'హిందీ',
    hr: 'క్రొయేషియన్',
    hsb: 'అప్పర్ సోర్బియన్',
    ht: 'ஹைடியன் கிரியோல்',
    hu: 'హంగేరియన్',
    hy: 'ఆర్మేనియన్',
    id: 'ఇండోనేషియన్',
    ig: 'ఇగ్బో',
    ikt: 'ఇనువిన్నాక్టున్',
    is: 'ઇસલેન્ડિક్',
    it: 'ఇటాలియన్',
    iu: 'ఇనుక్టిటుట్',
    iuLatn: 'ఇనుక్టిటుట్ (లాటిన్)',
    ja: 'జపనీస్',
    ka: 'ജോർജിയൻ',
    kk: 'ಕಜಕ್',
    km: 'ఖ్మేర్',
    kmr: 'కర్దీష్ (ఉత్తర)',
    kn: 'ಕನ್ನಡ',
    ko: 'కొరియన్',
    ku: 'కర్దీష్ (మధ్య)',
    ky: 'కిర్గిజ్',
    ln: 'లింగాలా',
    lo: 'లావో',
    lt: 'లిథువేనియన్',
    lug: 'గాండ',
    lv: 'లాట్వియన్',
    lzh: 'చైనీస్ (సాహిత్యిక)',
    mai: 'మైతిలి',
    mg: 'మలగాసీ',
    mi: 'మাওరీ',
    mk: 'మాసెడోనియన్',
    ml: 'మലയాళం',
    mnCyrl: 'మంగోలియన్ (సిరిలిక్)',
    mnMong: 'మంగోలియన్ (ప్రాతినిధిక)',
    mr: 'మారాఠీ',
    ms: 'మలయం',
    mt: 'ಮಾಲ್ಟೀಸ್',
    mww: 'హ్మాంగ్ డా',
    my: 'మయన్మార్ (బర్మీస్)',
    nb: 'நார்வேஜியன்',
    ne: 'నేపాలీ',
    nl: 'డచ్',
    noSearchLang: 'భాషা మద్దతు ఇవ్వబడదు',
    nso: 'సెసోథో సా లెబోయా',
    nya: 'న్యాన్జా',
    or: 'ఓడియా',
    otq: 'క్వెరెటారో ఓటోమి',
    pa: 'పంజాబీ',
    pl: 'పోలిష్',
    placeholder: 'శోధన',
    prs: 'దారి',
    ps: 'పాష్టో',
    pt: 'పోర్చుగీస్ (బ్రెజిల్)',
    ptPT: 'పోర్చుగీసు (పోర్చुगల్)',
    ro: 'రోమానియన్',
    ru: 'రష్యన్',
    run: 'రుండి',
    rw: 'కిన్యార్వాండా',
    sd: 'సింధీ',
    si: 'సింహళ',
    sk: 'స్లోవాక్',
    sl: 'స్లోవేనియన్',
    sm: 'సామోఅన్',
    sn: 'షోనా',
    so: 'సోమాలి',
    sq: 'అల్బేనియన్',
    srCyrl: 'సెర్బియన్ (సిరిలిక్)',
    srLatn: 'సెర్బియన్ (లాటిన్)',
    st: 'సెసోతో',
    sv: 'స్వీడిష్',
    sw: 'స్వాహిలీ',
    ta: 'తమిళం',
    te: 'తెలుగు',
    th: 'తాయ్',
    ti: 'తిగ్రిన్యా',
    tk: 'టర్క్‌మెన్',
    tlhLatn: 'క్లింగన్',
    tlhPiqd: 'క్లింగన్ (pIqaD)',
    tn: 'సెట్స్వానా',
    to: 'టాంగాన్',
    tr: 'టర్కిష్',
    tt: 'తాటార్',
    ty: 'తహిటీ',
    ug: 'ఉయ్‌గుర్',
    uk: 'యుక్రేనియన్',
    ur: 'ఉర్దూ',
    uz: 'ఉజ్బెక్ (లాటిన్)',
    vi: 'వియెట్నామీస్',
    xh: 'ਝੋਸਾ',
    yo: 'యోరుబా',
    yua: 'యుకాటెక్ మయా',
    yue: 'కాంటోనీస్ (ప్రస్తుత ప్రదర్శన)',
    zh: 'చైనీస్',
    zhHans: 'చైనీస్ సింప్లిఫైడ్',
    zhHant: 'చైనీస్ సంప్రదాయ',
    zu: 'జులు',
  },
  login: {
    and: 'మరియు',
    btn: 'గూగుల్‌తో లాగిన్ చేయండి',
    btn1: 'ఇప్పుడే లాగిన్ చేయండి',
    desc: 'మరింత అనుభవాలను తెరవడానికి లాగిన్ చేయండి',
    policy: 'ప్రైవసీ పాలసీ',
    terms: 'వినియోగ నిబంధనలు',
    tips: 'సైన్ అప్ చేయడం ద్వారా, నేను అంగీకరిస్తున్నాను',
    title: 'నోమ్‌కు స్వాగతం',
  },
  pageFooter: {
    follow: { facebook: 'ఫేస్‌బుక్', title: 'అనుసరించు', twitter: 'ట్విట్టర్' },
    legal: { policy: 'గోప్యతా విధానం', terms: 'సేవా నిబంధనలు', title: 'చట్టపరమైన' },
    product: {
      image: 'ఇమేజ్ అనువాదం',
      pdf: 'పిడిఎఫ్ అనువాదం',
      title: 'ప్రొడక్ట్‌లు',
      video: 'వీడియో అనువాదం & సమరీశన',
      web: 'వెబ్ అనువాదం మరియు సారాంశం',
    },
    resources: { title: 'వనరులు' },
    tools: { title: 'సాధనాలు', pdf: 'PDF అనువాదం' },
  },
  pageHeader: {
    contact: 'సంప్రదించండి',
    help: 'సహాయం',
    logout: 'లాగ్ అవుట్',
    logoutSucc: 'లాగ్ అవుట్ అయ్యింది.',
    pricing: 'ధరలు',
    settings: 'సెట్టింగ్‌లు',
    signUp: 'లాగ్ ఇన్',
  },
  pdf: {
    autoDetect: 'ఆటో-డిటెక్ట్',
    cancelBtn: 'రద్దు చేయు',
    cancelUpload: 'రద్దు చేయు',
    chatPdf: {
      summaryError: 'సమ్మారీ విఫలమైంది, దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి',
      chatError: 'చాట్ విఫలమైంది, దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి',
      Search: 'శోధించు',
      cancel: 'రద్దు చేయు',
      chatTitle: 'నోమ్‌కు స్వాగతం! మీ PDF యొక్క సారాంశం ఇక్కడ ఉంది:',
      clear: 'స్పష్టమైన',
      clearContent:
        'ఇది కొత్త సంభాషణను ప్రారంభిస్తుంది. ప్రస్తుత సంభాషణను సేవ్ చేయబడదు. మీరు ఖచ్చితంగా అనుకుంటున్నారా?',
      clearDialogTitle: 'ధృవీకరించండి',
      clearSucc: 'సफలంగా పూర్తయింది',
      copy: 'కాపీ',
      copySucc: 'కాపీ చేయబడింది',
      delete: 'తొలగించు',
      deleteCancel: 'రద్దు చేయు',
      deleteContent: 'ఈ PDF ను తొలగించిన తర్వాత పునరుద్ధరించలేము. మీరు ఖచ్చితంగా అనుకుంటున్నారా?',
      deleteOk: 'తొలగించు',
      deleteSuccess: 'మూసివేయబడింది',
      deleteTitle: 'తొలగించాలని ధృవీకరించు',
      expand: 'పडిపోవడం',
      historyTitle: 'చరిత్ర',
      listError:
        'రీడింగ్ లిస్ట్‌ను లోడ్ చేయలేకపోయింది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
      loading: 'లోడ్ అవుతుంది...',
      noDataDesc: 'ఇంకా చరిత్ర లేదు.',
      noMore: 'ఇక ప్రదేశం లేదు.',
      placeholder: 'ఈ PDF గురించి ఏదైనా ప్రశ్నించండి',
      summaryTitle: 'ఈ ప్రశ్నలలో మీకు ఆసక్తి ఉండலாமు:',
    },
    collectionEmpty: 'మీ సేకరణ ఖాళీగా ఉంది.',
    collectionTab: 'నోట్లు',
    dataLoading: 'లోడ్ అవుతుంది...',
    dialogContent: 'మీరు దీనిని తొలగించాలని నிச்சయంగా అనుకుంటున్నారా?',
    dialogTitle: 'కాన్ఫర్మ్ చేయండి',
    download: {
      both: 'బిలింగ్వల్',
      btn: 'సేవ్',
      cancel:
        'ఈ విండოქు మూసివేస్తే PDF డౌన్‌లోడ్ రద్దు అవుతుంది. మీరు రద్దు చేయాలని నిజంగా అనుకుంటున్నారా?',
      desc: 'డివైస్‌కు సేవ్ చేయండి: అనువాదాలను ఇమేజ్‌లుగా డౌన్‌లోడ్ చేస్తుంది; సేవ్ & ప్రింట్: కాపీ సપోర్ట్‌తో మूल ఫార్మాట్‌లో అనువాదాలను డౌన్‌లోడ్ చేస్తుంది.',
      download: 'డౌన్‌లోడ్',
      downloadMsg1: 'PDF అనువాద పురోగతి:',
      downloadMsg2: 'అంచనా మిగిలిన సమయం:',
      downloadSucc: 'PDF సిద్ధం! సేవ్ చేయడానికి క్లిక్ చేయండి.',
      downloadTip:
        'PDF ను డౌన్‌లోడ్ చేస్తోంది. డౌన్‌లోడ్ లోపాలను నివారించడానికి ఈ విండోను మూసకూడదు.',
      error: 'సేవ్ చేయడం విఫలమైంది. బదులుగా ప్రింట్ చేయడానికి ప్రయత్నించండి.',
      fileName: 'ఫైల్ పేరు:',
      fileType: 'ఫైల్ రకం:',
      loading: 'సేవ్ చేస్తున్నాము...',
      loading2: 'లోడ్ అవుతుంది...',
      minute: 'నిమిషాలు...',
      msg1: 'ఈ ప్రलेखంలోని కొన్ని అనువాదాలు మూల టెక్స్ట్ కంటే పొడవుగా ఉంటాయి మరియు డౌన్‌లోడ్ చేసిన ఫైల్‌లో ఓవర్‌లాప్ થઈ શકે છે. వెబ్‌పేజ్‌లో చదవాలని మేము సిఫార్సు చేస్తాము.',
      msg2: 'అనువాదం ఇంకా పూర్తి క未至దు. అనువాదం పూర్తి కాగాకప్పుడు డౌన్‌లోడ్ చేయండి.',
      msg3: 'కొన్ని అనువాదాలు చాలా పొడవుగా ఉంటాయి. టెక్స్ట్ ఓవర్‌ల్యాప్‌ను నివారించడానికి వెబ్‌పేజ్‌లో చదవండి.',
      msg4: 'ఉద్వహణలు ప్రోగ్రెస్‌లో ఉన్నాయి. పూర్తి થયిన తర్వాత మళ్లీ ప్రయత్నించండి.',
      progress:
        'PDFను అనువదిస్తున్నాను. ప్రోగ్రెస్: {{progress}}, అంచనా మిగిలిన సమయం: {{minutes}} నిమిషాలు...',
      save: 'డివైస్‌కు సేవ్ చేయండి',
      savePrint: 'సేవ్ & ప్రింట్',
      success: 'డౌన్‌లోడ్ చేయబడింది',
      trans: 'అనువాదం మాత్రమే',
      transContinue: 'అనువాదం కొనసాగించండి',
    },
    downloadBtn: 'డౌన్‌లోడ్',
    dragTipModal: {
      black: 'స్పేస్',
      leftKey: 'ఎడమ బటన్',
      ok: 'అవును అర్థం అయింది',
      press: 'ప్రెస్',
      tips: 'డ్రాగ్ చేసి చూడడం',
    },
    entry: 'PDFలు',
    fileErrMsg:
      'ఫైల్ రీడింగ్ విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    fileMsg: 'ప్రస్తుత ఫైల్ పరిమాణం:',
    fileMsg2: 'దయచేసి 300MB కంటే చిన్న ఫైల్‌ను అప్‌లోడ్ చేయండి.',
    freeBannerBtn: 'అప్‌గ్రేడ్',
    freeBannerTips: 'ఫ్రీ PDF అనువాదాల పరిమితి చేరింది',
    guide: {
      placeholder: 'పిడిఎఫ్ లింక్‌ను ఇక్కడ పేస్ట్ చేయండి',
      start: 'అనువాదం ప్రారంభించండి',
      text1: 'ద్విభాషా ప్రచారం',
      text2:
        'మూల పాఠం మరియు అనువాదాన్ని పక్కపక్కలో పోల్చడానికి ద్విజన మధ్య చదవండి, మీ సామర్థ్యాన్ని మెరుగుపరచడం.',
      text3: 'మీ PDF తో చాట్ చేయండి',
      text4:
        'AI-సమర్థిత విశ్లేషణ మరియు సారాంశం. మీ PDF గురించి ప్రశ్నలు అడగండి మరియు తక్షణ సమాధానాలు పొందండి.',
      text5: 'సચ్చు మరియు సమర్థవంతమైన',
      text6: 'ఉயർന്ന ఖచ్చితత్వం మరియు సామర్థ్యం కోసం AI-పవర్డ్ PDF అనువాదం.',
      title1: 'ద్విజęzy అనువాదం',
      title2: 'మీ PDF తో చాట్ చేయండి',
      toast: '.pdf తో ముగించే చెల్లుబాటు అయ్యే ఆన్‌లైన్ PDF లింక్‌ను ప్రవేశపెట్టండి',
    },
    hasTransTask: 'ఒక అనువాద ప్రయత్నం ప్రారంభమైంది. దయచేసి వేచి ఉండండి.',
    hoverTrans: 'హోవర్-టు-ట్రాన్స్‌లేట్ పేరాగ్రాఫ్‌లు',
    initial: 'PDFని అనువదించు',
    installText: 'రోజువారీ అనువాదాలకు మీ వన్-స్టాప్ సోల్యూషన్.',
    installText2: 'ముందుగా ఎక్స్టెన్షన్‌ను ఇన్‌స్టాల్ చేయండి',
    installTips:
      'మరింత PDF అనువాదాలు మరియు స్మూథర్ వెబ్‌సైట్ అనువాదాల కోసం ఎక్స్‌టెన్షన్‌ను ఇన్‌స్టాల్ చేయండి:',
    kw: 'ప్రధాన ఆహారం',
    link: 'లింక్',
    listError:
      'PDF లోడ్ చేయడం విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    memoTotalCount: 'మొత్తం 1 వస్తువు',
    new: 'న్యూ ఫైల్',
    noId: 'ఫైల్ ఐడి కనుగొనలేదు.',
    notPdf: 'PDF ఫైల్‌లు మాత్రమే.',
    okBtn: 'తొలగించు',
    okBtn2: 'సమજించాను',
    original:
      'మీరు ఖచ్చితమైన మరియు నమ్మదగిన AI, ఒక నిర్దిష్ట JSON స్కీమాకు ఖచ్చితంగా అనుగుణంగా JSON అవుట్‌పుట్‌ను తయారు చేయడానికి రూపొందించబడ్డారు.\n\nమీరు ఈ నియమాలను అనుసరించాలి:\n1. JSON స్కీమా నిర్మాణాన్ని ఖచ్చితంగా అనుసరించండి.\n2. అన్ని డేటా రకాలు, అవసరమైన క్షేత్రాలు మరియు పరిమితులను ఖచ్చితంగా మ్యాచ్ చేయండి.\n3. ఇతర ప్రశ్నలు, వివరణలు, మార్క్‌డౌన్ లేదా వ్యాఖ్యలను చేర్చవద్దు.\n4. కేవలం JSON бъект్‌ను అవుట్‌పుట్ చేయండి — కోడ్ బ్లాక్‌లు లేదు, ప్రీఅంబుల్ లేదు, ర్యాపింగ్ లేదు.\n\nస్కీమా సమాచారం క్రింద ఇవ్వబడింది.\n- స్కీమా పేరు: translate_result\n- JSON స్కీమా:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'పారలెల్',
    parseErrDialogContent:
      'ఈ PDF లింక్‌ను ప్రత్యక్షంగా అనువదించలేరు. దయచేసి PDFను డౌన్‌లోడ్ చేసి అనువదన కోసం అప్‌లోడ్ చేయండి.',
    parseErrTips: 'ఫైల్‌ను పార్స్ చేయడం విఫలమైంది',
    parseFileToast:
      'ఫైల్‌ను పార్స్ చేయడం విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌తో సంప్రదించండి.',
    pdfLoading: 'పార్సింగ్...',
    searchPlaceholder: 'శోధించు',
    selectTrans: 'అనువదించడానికి పाठాన్ని ఎంచుకోండి',
    shareBtn: 'షేర్',
    shareBtnText1: 'షేర్ లింక్‌ను జనరేట్ చేయండి',
    shareBtnText2: 'షేర్ చేయబడిన కంటెంట్‌ను అప్‌డేట్ చేయండి',
    shareModal: {
      cancel: 'రద్దు చేయు',
      copy: 'కాపీ',
      copySucc: 'లింక్ కాపీ చేయబడింది',
      custom: 'కస్టమైజ్ చేయండి:',
      errMsg: 'ఎంచిన కంటెంట్ పూర్తిగా అనువదించబడలేదు. షేర్ చేయడానికి ముందు అనువదించండి.',
      gen: 'షేర్',
      modify: 'సవరించు',
      notSupport: 'ఈ భాషా ప్రస్తుతం మద్దతు చేయబడదు.',
      page: 'పేజీలు',
      pageNuErr: 'విలువైన పేజీ సంఖ్యను ఎంటర్ చేయండి.',
      range: 'విస్తృతి:',
      remain: 'శेषించిన',
      remain1: 'మొత్తం అంచనా సమయం:',
      search: 'శోధించు',
      settings: 'షేర్ సెట్టింగ్‌లు:',
      shareSetting: 'షేర్ సెట్టింగ్‌లు',
      shareText: 'షేర్',
      shareTips: 'మీ స్నేహితులతో అనువదించిన PDF లింక్‌ను పంచుకోండి:',
      sourceLang: 'నుండి:',
      target: 'కు:',
      text1: 'షేర్ సెట్టింగ్‌లు',
      text2: 'షేర్ లింక్‌ను సృష్టించు',
      totalPage: 'మొత్తం 1 పేజీ',
      trans: 'అనువదించు',
      translateTips:
        'సూచన: అనువాదం కొంత సమయం పట్టుతుంటే, మీరు ఈ విండో ను మూసి తర్వాత షేర్ చేయலாமు.',
      translating: 'PDFను అనువదిస్తున్నాను...',
      update: 'షేర్ లింక్‌ను అప్‌డేట్ చేయండి',
    },
    shareMsg1: 'షేర్ లింక్ సృష్టించబడింది.',
    shareMsg2: 'షేర్ చేయబడిన కంటెంట్ అప్‌డేట్ చేయబడింది.',
    shareMsg3:
      'షేర్ లింక్ తయారుచేయడం విఫలమైంది. దయచేసి తర్వాత ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    shareMsg4:
      'షేర్ చేయబడిన కంటెంట్‌ను అప్‌డేట్ చేయడం విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    shareTips: 'మీ PDF అనువాదం సిద్ధంแล้ว! దీన్ని మీ స్నేహితులతో పంచుకోండి.',
    start: 'మీ ఉచిత ట్రయల్‌ను ప్రారంభించండి',
    thumbnail: 'విషయ సూచిక',
    toast1: 'PDF లోడ్ అవుతోంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
    toast2: 'PDF కంటెంట్ ప్రాసెస్ చేయబడుతోంది. డయాలాగ్ ప్రస్తుతం మద్దతు లేదు.',
    toast3: 'డౌన్‌లోడింగ్ జరుగుతుంది. డౌన్‌లోడ్ పూర్తయ్యాక తిరిగి ప్రయత్నించండి.',
    toolbar: { Adjust: 'సమंजనం చేయు', autoFit: 'ఆటో-ఫిట్' },
    trans: 'అనువాదం',
    transSucc: 'అనువాదం విజయవంతంవైంది!',
    unLoginToast: 'ఈ ఫీచర్‌ను ఉపయోగించడానికి దయచేసి లాగ్ ఇన్ చేయండి.',
    uploadBtn: 'అప్‌లోడ్',
    uploadErr:
      'ఫైల్ అప్‌లోడ్ విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    uploadErrSignUrl:
      'అప్‌లోడ్ URL పొందలేక పోయింది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌కు సంప్రదించండి.',
    uploadMsg1: 'ఇక్కడ మీ ఫైల్‌ను డ్రాగ్ & డ్రాప్ చేయండి.',
    uploadMsg2: 'ద ஆதరించబడే ఫైల్ రకాలు: PDF  |  గరిష్ట ఫైల్ పరిమాణం: 300MB',
    uploadMsg3: 'ఇక్కడ ఫైళ్లను ఎంచుకోవడానికి క్లిక్ చేయండి లేదా డ్రాగ్ & డ్రాప్ చేయండి.',
    uploading: 'అప్‌లోడ్ చేస్తోంది',
    uploadingMsg: 'అప్లోడ్ చేయబడుతుంది. దయచేసి వేచి ఉండండి.',
    uploadingMsg1: 'ఫైల్ ატვირთული হচ্ছে। దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
    uploadingMsg2: 'ఒక ఫైల్ ప్రస్తుతం మార్చబడుతుంది. క్షమించండి తర్వాత మళ్లీ ప్రయత్నించండి.',
    uploadingMsg3:
      'కన్వర్షన్ ప్రోగ్రెస్ రిక్వెస్ట్ విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌తో సంప్రదించండి.',
    uploadingMsg4:
      'నోమ్ స్థానిక ఫైళ్ళను యాక్సెస్ చేయలేడు. అనువాదం కోసం మాన్యువల్‌గా పిడిఎఫ్‌ను అప్‌లోడ్ చేయండి.',
    uploadingMsg5:
      'ఫైల్ URL పొందలేకపోయింది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి లేదా సపోర్ట్‌తో సంपर్కించండి.',
    video: 'వీడియో',
    vipBannerBtn: 'అప్‌గ్రేడ్',
    vipBannerTips: 'ఈ నెలకు మీ PDF అనువాద పరిమితిని మీరు చేరారు.',
    webTrans: 'ఫుల్ క్రాస్-రిఫరెన్స్',
  },
  pricing: {
    FAQ: 'ხშირად დასმული კითხვები',
    FQAObj: {
      a1: 'అవును, నోమ్ తక్షణమే ఉపయోగించగల మुफ్త ప్లాన్‌ను అందిస్తుంది.',
      a2: 'మేము మూడు మెమ్బర్షిప్ ప్లాన్‌లను అందిస్తున్నాము: ప్రో, ప్రో+, మరియు ఎంటర్‌ప్రైజ్. మీరు మాసికంగా లేదా వార్షికంగా చెల్లించాలని ఎంచుకోవచ్చు. వార్షిక బిల్లింగ్ గణనీయమైన పొదుపులను అందిస్తుంది.',
      a3: 'రెండు ప్లాన్‌లలో కూడా అన్ని ఫీచర్‌లు అందుబాటులో ఉన్నాయి. ప్రధాన తేడా ఖర్చు: వార్షిక సబ్‌స్క్రిప్షన్‌లు మొత్తం స్థాయిలో తక్కువ ఖర్చవుతాయి. మాసిక సబ్‌స్క్రిప్షన్‌లు ప్రతి మాసానికి బిల్లు వేయబడతాయి, అయితే వార్షిక ప్లాన్‌లు సంవత్సరానికి ఒకసారి బిల్లు వేయబడతాయి.',
      a4: 'మీ అకౌంట్ సెట్టింగ్‌లలో మీరు ఎప్పుడైనా మీ సబ్స్క్రిప్షన్‌ను రద్దు చేయலாமు.',
      q1: 'ఫ్రీ ప్లాన్ ఉందా?',
      q2: 'ఏ ప్రైసింగ్ ప్లాన్‌లు మరియు ప్రదాన ఐచ్చికங்களు అందుబాటులో ఉన్నాయి?',
      q3: 'మాసిక సబ్స్క్రైబ్ చేయడం మరియు వార్షిక సబ్స్క్రైబ్ చేయడం మధ్య ఏ వ్యత్యాసం ఉంది?',
      q4: 'నా సబ్స్క్రిప్షన్‌ను ఎలా రద్దు చేయగలను?',
    },
    around: 'చుట్టూ',
    billedMonthly: 'మాసిక బిల్ చేయబడుతుంది',
    billedYearly: 'సంవత్సరానికి బిల్లింగ్ చేయబడుతుంది',
    day: 'రోజు',
    desc: 'ప్లాన్‌లను పోల్చండి & సেরా ఎంచుకోండి',
    detailedCompare: 'ప్లాన్‌లను పోల్చండి',
    discount: '20% తగ్గింపు',
    enterprise: {
      benefit1: 'ప్రయоритీ కస్టమర్ సపోర్ట్',
      benefit2: 'బహుళ వినియోగదారులు',
      benefit3: 'ప్రయత్నపూర్వక పరిష్కారాలు',
      benefit5: 'ప్రత్యేక క ਖాతా మేనేజర్',
      btn: 'మమ్మల్ని సంప్రదించండి',
      recommendText: 'కస్టమ్ ప్లాన్‌లు (≥3 మంది)',
      talkToUs: 'సంప్రదించండి',
    },
    free: {
      benefit1: 'ఇన్స్టంట్ అనువాదం 100 సార్లు/రోజు',
      benefit2: 'వెబ్సైట్ అనువాదం & సారాంశం',
      benefit3: '30 ఇమేజ్ అనువాదాలు',
      benefit4: 'వీడియో అనువాదం & సారాంశం',
      benefit5: '10 పిడిఎఫ్ అనువాదాలు',
      benefit6: '5,000 టోకెన్‌లు',
      btn: 'ఇది ఉచితంగా ప్రయత్నించండి',
      recommendText: 'ఫ్రీ ట్రయల్',
    },
    imageTranslation: 'ఇమేజ్ అనువాదం',
    month: 'మాసం',
    monthly: 'మాసిక',
    pageTitle: 'ధరలు',
    pdf: {
      chat: 'PDF చాట్ క్విరీలు',
      maxPage: 'ప్రతి PDFకు గరిష్ట పేజీలు',
      translation: 'PDF అనువాదం',
    },
    preMonth: 'ప్రతి మాసం',
    pro: {
      benefit1: 'ప్రయామిక కస్టమర్ సపోర్ట్',
      benefit2: '1,000,000 టోకెన్లు/మాసం',
      benefit3: 'వెబ్‌సైట్ అనువాదం మరియు సారాంశం',
      benefit4: '200 ఇమేజ్ అనువాదాలు',
      benefit5: 'వీడియో అనువాదం & సారాంశం',
      benefit6: '200 పిడిఎఫ్ అనువాదాలు',
      btn: 'ప్రారంభించు',
      recommendText: 'చాలా ప్రసిద్ధమైన',
    },
    proPlus: {
      benefit1: 'ప్రయత్నం కస్టమర్ సపోర్ట్',
      benefit2: '3,000,000 టోకెన్లు/మాసం',
      benefit3: 'వెబ్సైట్ అనువాదం & సారాంశం',
      benefit4: '500 చిత్ర అనువాదాలు',
      benefit5: 'వీడియో అనువాదం మరియు సారాంశం',
      benefit6: '500 పిడిఎఫ్ అనువాదాలు',
      recommendText: 'ఉత్తమ విలువ',
    },
    video: { summary: 'వీడియో సమారీ', translation: 'వీడియో అనువాదం' },
    web: {
      contrastiveTranslation: 'ద్విభాషా అనువాదం',
      dictionaryTranslation: 'సెలెక్షన్ అనువాదం',
      hoverTranslation: 'హోవర్ ట్రాన్స్లేషన్',
      instantTranslation: 'తక్షణ అనువాదం',
      summary: 'వెబ్ పేజ్ సమరీ',
    },
    yearly: 'వార్షికం',
  },
  privacy: {
    block1:
      'నోమ్ ("నోమ్," "మేము," "మా" లేదా "మమ్మకు") మీ వ్యక్తిగత సమాచారాన్ని గౌరవిస్తుంది మరియు మమ్మకు మీ నుంచి లేదా మీ గురించి పొందిన ఏదైనా సమాచారాన్ని రక్షించడానికి కట్టుబద్ధం છે. ఈ గోప్యతా విధానமు మా వెబ్సైట్, అనువర్తనాలు మరియు సేవలు (సమూహంగా "సేవలు") వినియోగించడం నుండి వ్యక్తిగత సమాచారాన్ని సేకరించడం లేదా ఉపయోగించడం సంబంధిత మా ప్రాక్టీస్‌లను వివరిస్తుంది. మా వ్యాపార ఉత్పత్తి కస్టమర్ల సంబంధంలో మేము నిర్వహించే కంటెంట్‌కు ఈ గోప్యతా విధానం వర్తించదు (ఉదా., మా API). ఈ డేటాను ఉపయోగించడం మా కస్టమర్ ఒప్పందం కు అధीनంగా ఉంటుంది, ఇది ఈ ఉత్పత్తులకు ప్రాప్యత మరియు ఉపయోగాన్ని కవర్ చేస్తుంది.',
    block10:
      'మేము ఆన్‌లైన్ మరియు ఆఫ్‌లైన్ వ్యక్తిగత సమాచారాన్ని నష్టం, దుర్వినియోగం మరియు అనధికृत ప్రాప్తి, వెలికితీర్పు, మార్పు లేదా శత్రు చర్యల నుండి రక్షించడానికి వాణిజ్య ரీజనబుల్ సాంకేతిక, పరిపාලన మరియు సంస్థాత్మక நடவடிக்கைகளు అమలు చేస్తాము. అయితే, ఇంటర్నెట్ లేదా ఇమెయిల్ ప్రస్తుతీకరణ ఏదీ పూర్తి భద్రత లేదా ఖచ్చితత్వాన్ని హామీ ఇవ్వలేదు. ప్రత్యేకించ하여, మమ్మలకు పంపబడిన లేదా మమ్మల నుండి పంపబడిన ఇమెయిల్‌లు భద్రంగా ఉండకపోవచ్చు. కాబట్టి, సేవ లేదా ఇమెయిల్ ద్వారా మమ్మలకు ఏ సమాచారాన్ని పంపాలో నిర్ణయించేటప్పుడు మీరు ప్రత్యేకంగా జాగ్రత్తగా ఉండాలి. అదనంగా, సేవలో లేదా మూడవ పార్టీ వెబ్‌సైట్‌ల భద్రత సెట్టింగ్‌లు లేదా భద్రత நடவடிக்கைகளలో గోప్యత సెట్టింగ్‌లు లేదా భద్రత நடவடிக்கைகளకు ఎటువంటి అడ్డంకులకు మేము బాధ్యత వహించము. మేము మీకు సేవలను అందించడానికి లేదా వివాదాలను పరిష్కరించడం, భద్రత మరియు భద్రత కారణాలు, లేదా మా చట్టపరమైన విధ్యులను నెరవేర్చడం వంటి ఇతర చట్టబద్ధ వ్యాపార ప్రయోజనాల కోసం అవసరమైనంత కాలం వరకు మీ వ్యక్తిగత సమాచారాన్ని సంరక్షిస్తాము. మేము వ్యక్తిగత సమాచారాన్ని సంరక్షిస్తున్న కాల వ్యవధి అనేక కారకాలపై ఆధారపడతుంది, వంటి సమాచారానికి మొత్తం, స్వభావం, సంవేదనశీలత, అనధికृत వాడకం లేదా వెలికితీర్పు యొక్క సంభావ్య ప్రమాదాలు, మేము సమాచారాన్ని ప్రాసెస్ చేసే ప్రయోజనాలు మరియు ఇతర చట్టబద్ధ పరిగణనలు.',
    block11:
      'మేము ఈ గోప్యతా నియమాన్ని కాలానుగుణంగా నవీకరించலாமు. మేము అలా చేసినప్పుడు, వర్తింపు చేయగల చట్టం వేరుగా ఆవశ్యపడినట్లే కాకుండా, మేము ఈ పేజీలో నవీకరించిన వెర్షన్‌ను పోస్ట్ చేస్తాము.',
    block12:
      'ఈ ప్రైవేసీ పాలిసీ గురించి మీకు సమాధానం లేని ప్రశ్నలు లేదా ఆందోళనలు ఉన్నట్లయితే, దయచేసి మా కస్టమర్ సర్వీస్‌తో సంప్రదించండి. ఇమెయిల్:',
    block2: 'మేము మీతో సంబంధిత క్రింది వ్యక్తిగత సమాచారాన్ని ("వ్యక్తిగత సమాచారం") సేకరిస్తాము:',
    block3:
      'మీరు అందించిన సమాచారం: మీరు మా సేవలను ఉపయోగించడానికి ან మమ్మతో సంభాషించడానికి ఖాతాను సృష్టించినప్పుడు, మేము క్రింది విధంగా వ్యక్తిగత సమాచారాన్ని సేకరిస్తాము:',
    block4:
      'సేవలను ఉపయోగించడం నుండి స్వయంచాలకంగా పొందిన వ్యక్తిగత సమాచారం: మీరు సేవలను యాక్సెస్ చేసినప్పుడు, ఉపయోగించినప్పుడు లేదా ఇంటరాక్ట్ చేసినప్పుడు, మీ యాక్సెస్, ఉపయోగం లేదా ఇంటరాక్షన్ గురించి కింది సమాచారాన్ని మేము పొందుతాము ("టెక్నికల్ సమాచారం"):',
    block5: 'మేము వ్యక్తిగత సమాచారాన్ని క్రింది ప్రయోజనాల కోసం ఉపయోగించலாமు:',
    block6:
      'సమారంశం లేదా గుర్తించలేని సమాచారం: మేము వ్యక్తిగత సమాచారాన్ని ఏకీకరించవచ్చు లేదా గుర్తించలేనిదిగా మార్చవచ్చు, తద్వారా గుర్తించడానికి తిరిగి ఉపయోగించకుండా ఉంచవచ్చు మరియు అలాంటి సమాచారాన్ని మా సేవల ప్రసిద్ధతను విశ్లేషించడానికి, మా సేవలను మెరుగుపరచడానికి మరియు లక్షణాలను జోడించడానికి, పరిశోధన చేయడానికి మరియు ఇతర సంబంధిత ప్రయోజనాల కోసం ఉపయోగించవచ్చు. అదనంగా, మేము మా సేవా వినియోగదారుల సాధారణ ప్రవర్తన మరియు లక్షణాలను విశ్లేషించవచ్చు, ఏకీకరించిన సమాచారాన్ని మూడవ పార్టీలతో పంచుకోవచ్చు, అలాంటి ఏకీకరించిన సమాచారాన్ని ప్రచురించవచ్చు లేదా సాధారణంగా అందుబాటులో ఉంచవచ్చు. మేము సేవల ద్వారా, కుకీల ద్వారా మరియు ఈ గోప్యతా నియమంలో వివరించిన ఇతర మార్గాల ద్వారా ఏకీకరించిన సమాచారాన్ని సేకరించవచ్చు. మేము గుర్తించలేని సమాచారాన్ని అనానుబంధ లేదా గుర్తించలేని రూపంలో సంరక్షించి ఉపయోగిస్తుంది మరియు చట్టం ద్వారా అవసరం లేని ప్రయత్నం చేయకుండా అలాంటి సమాచారాన్ని తిరిగి గుర్తించ முயற்சிக்க மாட்டాం.',
    block7:
      'కొన్ని సందర్భాలలో, చట్టం ద్వారా అవసరం లేకపోతే, మమ్మలు మీ వ్యక్తిగత సమాచారాన్ని మీకు మరింత నోటీసు లేకుండా మూడవ పార్టీలకు అందజేస్తాము:',
    block8:
      'మీ భౌగోళిక స్థానం ఆధారంగా, యూరోపియన్ ఎకనామిక్ ఏరియా, యునైటెడ్ కింగ్‌డమ్ మరియు ప్రపంచవ్యాప్తంగా ఉన్న వ్యక్తులకు వారి వ్యక్తిగత సమాచారానికి సంబంధించి కొన్ని చట్టబద్ధ హక్కులు ఉండవచ్చు. ఉదాహరణకు, మీకు ఈ హక్కులు ఉండవచ్చు:',
    block9:
      'ఈ సేవలో నోమ్ tarafından నిర్వహించ거나 నియంత్రించబడని ఇతర వెబ్‌సైట్‌లకు లింక్‌లు ఉండலாமు, వీటిలో సోషల్ మీడియా సేవలు ("థర్డ్ పార్టీ వెబ్‌సైట్‌లు") ఉన్నాయి. థర్డ్ పార్టీ వెబ్‌సైట్‌లతో మీరు సाझਾ చేసే సమాచారం ఈ ప్రైవేసీ పాలసీ ద్వారా కాకుండా థర్డ్ పార్టీ వెబ్‌సైట్‌ల యొక్క ప్రత్యేక ప్రైవేసీ పాలసీలు మరియు సేవా నిబంధనల ద్వారా పరిపాలించబడుతుంది. మేము ఈ లింక్‌లను సౌకర్యం కోసం అందిస్తున్నాము మరియు ఈ వెబ్‌సైట్‌లకు మా ఆమోదం లేదా సమీక్షను సూచించలేదు. వారి ప్రైవేసీ పాలసీలు మరియు నిబంధనల గురించి సమాచారం కోసం థర్డ్ పార్టీ వెబ్‌సైట్‌లను ప్రత్యక్షంగా సంప్రదించండి.',
    subBlock1:
      'ఖాతా సమాచారం: మీరు మా ప్లాట్‌ఫారమ్‌లో ఖాతాను సృష్టించినప్పుడు, మేము మీ ఖాతాతో సంబంధిత సమాచారాన్ని సేకరిస్తాము, ఇందులో మీ పేరు, సంప్రదింపు సమాచారం, ఖాతా ధృవీకరణ వివరాలు, పేమెంట్ కార్డు సమాచారం మరియు లావాదేవీ చరిత్ర ("ఖాతా సమాచారం") ఉన్నాయి.',
    subBlock10: 'సేవలను అందించడం, నిర్వహించడం, నిర్వర్తించడం మరియు/లేదా విశ్లేషించడం;',
    subBlock11: 'మీతో మాట్లాడడం',
    subBlock12: 'కొత్త ఉత్పత్తులు మరియు సేవలను అభివృద్ధి చేయడం;',
    subBlock13:
      'చమৎకారము, నేరాల కార్యాచరణ లేదా మా సేవలను దుర్వినియోగం చేయకుండా నిరోధించడం మరియు మా ఐటి సిస్టమ్‌లు, ఆర్కిటెక్చర్ మరియు నెట్‌వర్క్‌ల భద్రతను రక్షించడం;',
    subBlock14: 'వ్యాపార బదిలీలను నిర్వహించడం;',
    subBlock15:
      'చట్టపరమైన బాధ్యతలు మరియు చట్టపరమైన ప్రక్రియలకు అనుగుణంగా ప్రవర్తించడం, మా హక్కులు, గోప్యత, భద్రత లేదా ఆస్తిని రక్షించడం, అలాగే మా అనుబంధ సంస్థలు, మీరు లేదా ఇతర మూడవ పార్టీల వాటిని కూడా రక్షించడం. ',
    subBlock16:
      'సప్లయర్స్ మరియు సروس్ ప్రొవైడర్‌లు: వ్యాపార సంચालన అవసరాలను తీర్చడం మరియు కొన్ని సేవలు మరియు ప్రయోగాలను నిర్వహించడంలో మాకు సహాయపడటానికి, మేము సవాల్సు సేవా ప్రొవైడర్‌లు, క్లౌడ్ సేవా ప్రొవైడర్‌లు మరియు ఇతర ఇన్ఫర్మేషన్ టెక్నాలజీ సేవా ప్రొవైడర్‌లు, ఇమెయిల్ కమ్యూనికేషన్ సాఫ్ట్వేర్ మరియు వెబ్ విశ్లేషణ సేవా ప్రొవైడర్‌లు మొదలైన సప్లయర్స్ మరియు సేవా ప్రొవైడర్‌లకు వ్యక్తిగత సమాచారాన్ని అందించலாமు. మా కోసం తమ విధులను నిర్వహిస్తున్నప్పుడు ఈ భాగస్వాములు మా దిశను పాటిస్తే మాత్రమే వ్యక్తిగత సమాచారాన్ని ప్రాప్తి చేస్తారు, ప్రాసెస్ చేస్తారు లేదా స్టోర్ చేస్తారు.',
    subBlock17:
      'వ్యాపార బదిలీలు: మేము వ్యూహాత్మక లావాదేవీలు, పునర్వ్యవస్థలు, దివாலిపత్యం, దివాలిపత్య ప్రవేశాలు లేదా సేవలను మరొక ప్రదాతకుడికి మార్పిడి చేస్తే (సమూహంగా "లావాదేవీలు"), మీ వ్యక్తిగత సమాచారం మరియు ఇతర సమాచారాలను లావాదేవీ భాగస్వాములు మరియు లావాదేవీలలో సహాయపడే ఇతర పార్టీలతో విశ్లేషణ సమయంలో పంచుకోవచ్చు మరియు ఇతర ఆస్తులతో కలిసి లావాదేవీలలో వారసత్వ లేదా అనుబంధ కంపెనీకి బదిలీ చేయవచ్చు.',
    subBlock18:
      'కాన్ని అవసరాలు: మేము మీ వ్యక్తిగత సమాచారాన్ని ప్రభుత్వ అధికారులు, పరిశ్రమా సొంతులు లేదా ఇతర మూడవ పార్టీలతో పంచుకోవచ్చు, మా సేవలతో మీ పరస్పర చర్య సమాచారంతో సహా: (1) చట్టం ద్వారా అవసరమైతే లేదా చట్టపరమైన బాధ్యతలను సంవరించడానికి આવ така ప్రయత్నం అవసరమని మేము నమ్మినట్లయితే; (2) మా హక్కులు లేదా ఆస్తిని రక్షించడానికి మరియు రక్షించడానికి; (3) మా నిబంధనలు, విధానాలు లేదా చట్టాలను ఉల్లంఘించినట్లు మేము ఏకపక్షంగా నిర్ణయించినట్లయితే; (4) మోసం లేదా ఇతర చట్టవిరుద్ధమైన కార్యకలాపాలను గుర్తించడానికి లేదా నిరోధించడానికి; (5) మా ఉత్పత్తులు, ఉద్యోగులు లేదా వినియోగదారులను లేదా ప్రజా భద్రత, భద్రత, సమగ్రతను రక్షించడానికి; లేదా (vi) చట్టపరమైన బాధ్యత నుండి రక్షించడానికి.',
    subBlock19:
      'మీ వ్యక్తిగత సమాచారాన్ని మరియు దాని ప్రాసెస్ ఎలా జరుగుతుందో సంబంధించిన సమాచారాన్ని ప్రాప్టు చేయండి.',
    subBlock2:
      'మీరు మా సేవలను ఉపయోగించినప్పుడు, మీరు ఇవ్విన ఇన్పుట్‌లు, ఫైల్ అప్‌లోడ్‌లు లేదా అభిప్రాయాల నుండి మేము వ్యక్తిగత సమాచారాన్ని సేకరిస్తాము ("కంటెంట్").',
    subBlock20: 'మా రికార్డుల నుండి మీ వ్యక్తిగత సమాచారాన్ని తొలగించడానికి అభ్యర్థన చేయండి.',
    subBlock21: 'మీ వ్యక్తిగత సమాచారాన్ని సరిచేయండి లేదా నవీకరించండి.',
    subBlock22: 'మీ వ్యక్తిగత సమాచారాన్ని మూడవ పార్టీకి బదిలీ చేయండి (డేటా పోర్టబిలిటీ).',
    subBlock23: 'మీ వ్యక్తిగత సమాచారాన్ని మేము ఎలా ప్రాసెస్ చేస్తామో పరిమితం చేయండి.',
    subBlock24:
      'మీ సహ్మతిని ఉపసంహరించండి—ప్రాసెసింగ్ కోసం చట్టపరమైన ప్రధాన స్థానంగా మేము సహ్మతిని ఆధారంగా పడుతున్నിടத്തે, మీరు ఎప్పుడైనా మీ సహ్మతిని ఉపసంహరించవచ్చు.',
    subBlock25: 'మేము మీ వ్యక్తిగత సమాచారాన్ని ఎలా ప్రాసెస్ చేస్తామో వ్యతిరేకించండి.',
    subBlock26: 'మా సేవలను మెరుగుపరచడం మరియు పరిశోధనను నిర్వహించడం;',
    subBlock3:
      'సంభాషణ సమాచారం: మీరు మమ్మల్ని సందేశాలు పంపితే, మేము మీ పేరు, సంప్రదింపు సమాచారం మరియు మీ సందేశాల మحتوى ("సంభాషణ సమాచారం") సేకరిస్తాము.',
    subBlock4:
      'సోషల్ మీడియా సమాచారం: ఇన్స్టాగ్రామ్, ఫేస్‌బుక్, మీడియమ్, ట్విటర్, యూట్యూబ్ మరియు లింకెడ్‌ఇన్ వంటి సోషల్ మీడియా వెబ్‌సైట్‌లలో మా పేజీలు ఉన్నాయి. మా సోషల్ మీడియా పేజీలతో మీరు ఇంటరాక్ట్ చేసేటప్పుడు, మీరు మాకు అందించాలని ఎంచుకునే వ్యక్తిగత సమాచారం, వంటి మీ సంప్రదింపు వివరాలను మేము సేకరిస్తాము ("సోషల్ సమాచారం"). అదనంగా, మా సోషల్ మీడియా పేజీలను హోస్ట్ చేసే కంపెనీలు మా సోషల్ మీడియా కార్యకలాపాలకు సంబంధించిన ఏకీభవించిన సమాచారం మరియు విశ్లేషణను మాకు అందిస్తాయి.',
    subBlock5:
      'లాగ్ డేటా: మా సేవలను ఉపయోగించేటప్పుడు మీ బ్రౌజర్ త автоматиquement పంపే సమాచారం. లాగ్ డేటામાં మీ ఇంటర్నెట్ ప్రోటోకాల్ (IP) అడ్రస్, బ్రౌజర్ రకం మరియు సెట్టింగ్‌లు, మీ అభ్యర్థనల తేది మరియు సమయం, మరియు మీరు మా వెబ్‌సైట్‌తో ఎలా ఇంటరాక్ట్ చేస్తారు వంటి వివరాలు ఉన్నాయి.',
    subBlock6:
      'వాడకా డేటా: మేము సేవను మీరు ఉపయోగించும் విధానం గురించి స్వయంచాలకంగా సమాచారం సేకరించవచ్చు, ఉదా., మీరు చూసే లేదా ఇంటరాక్ట్ చేసే కంటెంట్ రకాలు, మీరు ఉపయోగించే ఫీచర్లు, మీరు తీసుకునే చర్యలు, అలాగే మీ టైమ్ జోన్, దేశం, ప్రవేశం యొక్క తేది మరియు సమయం, యూజర్ ఏజెంట్ మరియు వెర్షన్, కంప్యూటర్ లేదా మొబైల్ పరికర్ రకం మరియు మీ కంప్యూటర్ కనెక్షన్.',
    subBlock7:
      'పరికర సమాచారం: ఇది పరికరం పేరు, ఆపరేటింగ్ సిస్టమ్, పరికర ఐడెంటిఫయర్ మరియు మీరు ఉపయోగించే బ్రౌజర్‌ను కలిగి ఉంటుంది. సేకరించిన సమాచారం మీరు ఉపయోగించే పరికర రకం మరియు దాని సెట్టింగ్‌లపై ఆధారపడుతుంది.',
    subBlock8:
      'కుక్కీస్: మేము మా సేవలను నిర్వహించడానికి మరియు నిర్వహించడానికి మరియు మీ అనుభవాన్ని మెరుగుపరచడానికి కుక్కీస్‌లను ఉపయోగిస్తాము. "కుక్కీ" అనేది మీరు సందర్శించే వెబ్సైట్ మీ బ్రౌజర్‌కు పంపే సమాచారం. మీరు మీ బ్రౌజర్‌ను అన్ని కుక్కీస్‌లను అంగీకరించడానికి, అన్ని కుక్కీస్‌లను తిరస్కరించడానికి లేదా కుక్కీ అందించినప్పుడు మీకు నోటిఫై చేయడానికి సెట్ చేయலாமి, తద్వారా మీరు ప్రతిసారీ అంగీకరించాలా అనేదాన్ని నిర్ణయించலாமు. అయితే, కుక్కీస్‌లను తిరస్కరించడం వెబ్సైట్‌లోని కొన్ని ప్రాంతాలు లేదా లక్షణాల ప్రదర్శన లేదా ప్రయోగశీలతను ఉపయోగించకుండా ప్ర之宝ేధిస్తుంది లేదా ప్రతికూల ప్రభావితం చేస్తుంది. కుక్కీస్‌ల గురించి మరింత సమాచారం కోసం, దయచేసి ఆల్ అబౌట్ కుక్కీస్‌ను సందర్శించండి.',
    subBlock9:
      'అనలిటిక్స్: వినియోగదారులు எలా సేవలను ఉపయోగిస్తారో విశ్లేషించడానికి మరియు సేవలను ఉపయోగిస్తున్నప్పుడు మీ అనుభవాన్ని మెరుగుపరచడానికి కుకీలను ఉపయోగించే వివిధ ఆన్‌లైన్ అనలిటిక్స్ ఉత్పత్తులను మేము ఉపయోగించலாமు.',
    subTitle1: 'మేము సేకరిస్తున్న వ్యక్తిగత సమాచారం',
    subTitle2: 'మేము వ్యక్తిగత సమాచారాన్ని ఎలా ఉపయోగిస్తాము',
    subTitle3: 'వ్యక్తిగత సమాచారాన్ని ప్రదర్శించడం',
    subTitle4: 'మీ హక్కులు',
    subTitle5: 'ఇతర వెబ్‌సైట్‌లకు లింక్‌లు',
    subTitle6: 'సమాచార భద్రత మరియు నిల్వ',
    subTitle7: 'ప్రైవేసీ పాలసీ యొక్క మార్పు',
    subTitle8: 'మమ్మల్ని ఎలా సంప్రదించాలి',
    title: 'గోప్యతా విధానం',
    updateTime: 'నవీకరించబడింది: మార్చి 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'అన్ని స్వీకరించు',
    text: 'మీ అనుభవాన్ని మెరుగుపరచడానికి, మేము కంటెంట్ మరియు సేవలను వ్యక్తిగతీకరించడానికి కూకీలను ఉపయోగిస్తాము.',
    title: 'ఈ వెబ్‌సైట్ కూకీలను ఉపయోగిస్తుంది',
  },
  slogen: 'సులభతమైన AI అసిస్టెంట్',
  stripe: {
    contact: 'ఏదైనా ప్రశ్నలు ఉంటే contact@noam.tools వద్ద మమ్మల్ని సంప్రదించండి!',
    fail: {
      btn: 'మళ్లీ ప్రయత్నించండి',
      text1: 'మీ పేమెంట్‌ను ప్రాసెస్ చేయలేక పోయాము.',
      text2: 'మీ కనెక్షన్‌ను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.',
      title: 'ప్రదానం విఫలమైంది',
    },
    succ: {
      btn: 'ప్రయాణం ప్రారంభం చేద్దాం',
      text1: 'నోమ్‌కు స్వాగతం',
      text2: 'ప్రారంభం చేద్దాం!',
      title: 'అభినందనలు',
    },
  },
  terms: {
    block1: 'నోమ్‌ను ఉపయోగించినందుకు ధన్యవాదాలు!',
    block10:
      '(ఎ) ఫీజ్ మరియు బిల్లింగ్. మీరు అనువైన ధర పేజీలోని ధర మరియు ప్రచటనల ప్రకారం లేదా మా మధ్య లిఖിതంగా ஒப్పుకున్నట్లుగా అన్ని ఫీజ్ ("ఫీజ్") చెల్లించுவீர்கள். మేము ఇన్వాయిస్‌లను జారీ చేసినట్లయినా లేదా ప్రదానం అందుకున్నట్లయినా ధర లోపాలను లేదా తప్పులను సరిచేయాలనే హక్కును సంରక్షిస్తాము. మీరు పూర్తి మరియు ఖచ్చితమైన బిల్లింగ్ సమాచారాన్ని అందిస్తారు, విలువైన మరియు అధికृत ప్రదాన పద్ధతిని కలుపుతుంది. మేము మీరి ప్రదాన పద్ధతిని ఒప్పుకున్న పеріఇతరంగా ఛార్జ్ చేస్తాము, కానీ మేము బిల్లింగ్ తేదీని సహేతుకంగా మార్చலாமు. మీరు నోమ్, దాని సంబంధిత సంస్థలు మరియు తృతীয় పార్టీ ప్రదాన ప్రాసెసర్‌లను మీ ప్రదాన పద్ధతిపై ఛార్జ్ చేయాలను అధికृतం చేస్తారు. మీ ప్రదానం విఫలమైతే, మేము మీకు లిఖిత నోటీస్‌ను అందిస్తాము మరియు ప్రదానం అందుకునే వరకు సేవాకు ప్రవేశాన్ని సస్పెండ్ చేసலாமు. ఈ ஒப்பந்தத்தில் ఇతర విధంగా ప్రvisionspecified చేయப்படినట్లు మినహా ప్రదానాలు రిఫండ్ చేయబడవు.',
    block11:
      'పన్నులు. వేరే పేర్కొనப்படದಿದ್ದರೆ, ఫీజులలో ప్రధాన ప్రభుత్వ, రాష్ట్ర, స్థానిక మరియు విదేశీ పన్నులు, రహితాలు మరియు సదৃశమైన అంచనాలు ("పన్నులు") వłączబడవు. మీ కొనుగోలలతో సంబంధించిన అన్ని పన్నులకు మీరు బాధ్యత వహిస్తారు, మా నికర ఆదాయంపై ఆధారపడిన పన్నులు మినహా మేము మీకు ఇన్వాయిస్ చేస్తాము. మీరు ప్రామాణికంగా వৈধ గోప్యతా ప్రకటనలను మాకు అందిస్తారు మరియు అలాంటి డేటాను నిర్వహించడానికి అవసరమైన సమ్మతులు పొందుతారు మరియు మీరు అలాంటి డేటాను వర్తింపు చెందే చట్టం ప్రకారం నిర్వహిస్తున్నீரని మమ్మకు హామీ ఇస్తారు.',
    block12:
      '(c) ధర మార్పులు. మీ ఖాతా మరియు/లేదా మా వెబ్‌సైట్ ద్వారా మీకు తెలుపుతూ మేము మా ధరలను మార్చலாமు. ధర పెరుగుదలలు పోస్ట్ చేయబడటం వెంటనే ప్రయోజనం పొందుతాయి. మార్పు యొక్క ప్రయోజన సేదుపు తర్వాత మీ ఖాతার కొస్ట్‌లకు ఏదైనా ధర మార్పులు వర్తిస్తాయి.',
    block13:
      '(d) వివాదాలు మరియు అపেক్షిత చెల్లింపులు. మీరు ఏదైనా ఫీజులు లేదా పన్నులను వివాదించాలనుకుంటే, ఇన్వాయిస్ తేదీ నుంచి ముప్పై (30) రోజులలోపు contact@noam.tools కు సంప్రదించండి.',
    block14:
      'ఫ్రీ యూజేజ్. ఫ్రీ క్రెడిట్‌లను పొందడానికి మీరు మల్టిపుల్ అకౌంట్‌లను సృష్టించలేరు. మీరు ఫ్రీ క్రెడిట్‌లను మంచి విశ్వాసంతో ఉపయోగించని మేము నిర్ణయిస్తే, మేము మీకు స్టాండర్డ్ ఫీజ్‌లను వసూలు చేసலாமి లేదా సేవೆಗಾಗి యాక్సెస్‌ను అందించడం ఆపી શકি।',
    block15:
      'గోప్యత. మీరు నోమ్ యొక్క గోప్య సమాచారానికి ప్రాప్యత కలిగి ఉండலாமు. సేవను ఉపయోగించే ప్రయోజనం కోసం మీరు ఈ నిబంధనలలో అనుమతించిన విధంగా మాత్రమే గోప్య సమాచారాన్ని ఉపయోగించవచ్చు. మీరు గోప్య సమాచారాన్ని ఎటువంటి మూడవ పార్టీకి వెల్లడించవద్దు మరియు మీరు మీ స్వంత పోలి గోప్య సమాచారాన్ని రక్షించే విధంగా తక్కువ కాదు రక్షణా ప్రదానం చేస్తుంది, కనీసం సహేతుక జాగ్రత్తతో. గోప్య సమాచారం అనేది నోమ్ చే గోప్యంగా ప్రదేశించబడిన సాధారణ ప్రజలకు అందుబాటులో లేని సమాచారం లేదా పరిస్థితులలో సమయంతో గోప్యంగా పరిశీలించబడాల్సిన సమాచారం, ఇందులో సాఫ్ట్వేర్, వివరణలు మరియు ఇతర సాధారణ ప్రజలకు అందుబాటులో లేని వ్యాపార సమాచారం ఉన్నాయి. గోప్య సమాచారం క్రింది విధంగా ఉన్న సమాచారాన్ని కలిగి ఉండదు: (1) మీ పార్టీకి దోషం లేకుండా సాధారణ ప్రజలకు సాధారణంగా అందుబాటులోకి వస్తుంది; (2) ఈ నిబంధనల ప్రకారం పొందటానికి ముందు మీకు గోప్యత బాధ్యత లేకుండా మీ కൈగా వచ్చింది; (3) మూడవ పార్టీ ద్వారా మీకు గోప్యత బాధ్యత లేకుండా చట్టపరంగా వెల్లడించబడింది; లేదా (4) మీరు గోప్య సమాచారాన్ని ఉపయోగించకుండా స్వతంత్రంగా అభివృద్ధి చేసినది. చట్టం, న్యాయాలయం లేదా ఇతర ప్రభుత్వ ఆదేశం ప్రకారం అవసరమైతే మీరు గోప్య సమాచారాన్ని వెల్లడించవచ్చు, కానీ మీరు నోమ్‌కు ముందుగా రచనాత్మక నోటీసును సహేతుక విధంగా అందించాలి మరియు సాధ్యమైనంతవరకు, వెల్లడింపు పరిధిని పరిమితం చేయడానికి సహేతుక ప్రయత్నాలు చేయాలి, వెల్లడింపు అభ్యర్థనలను எதிர vastaanచడంలో మమ్మల్ని సహాయం చేయడం వంటివి ఉన్నాయి.',
    block16:
      'సురక్షత. సేవా ప్రాప्तికి మరియు ఉపయోగానికి సహాయపడే సహేతుకమైన మరియు తగిన పద్ధతులను మీరు అమలు చేయాలి. సేవાનు ఉపయోగించేటప్పుడు ఏదైనా దుర్వలతలు లేదా ఉల్లంఘనలు కనుగొన్నట్లయితే, మీరు త్వరలో నోమ్‌తో సంప్రదించి దుర్వలత లేదా ఉల్లంఘన యొక్క వివరాలను అందించాలి.',
    block17:
      '((c) వ్యక్తిగత డేటా ప్రాసెసింగ్. మీరు వ్యక్తిగత డేటాను ప్రాసెస్ చేయడానికి సేవను ఉపయోగిస్తే, మీరు చట్టపరంగా సరిపోయే గోప్యతా ప్రకటనలను అందించాలి మరియు అలాంటి డేటాను ప్రాసెస్ చేయడానికి అవసరమైన సహ్మతిని పొందాలి, మరియు మీరు వర్తమాన చట్టాల ప్రకారం అలాంటి డేటాను నిర్వహిస్తున్నீரని మమ్మకు హామీ ఇస్తారు.)',
    block18:
      '(a) ముగింపు; సస్పెన్షన్. సేవાનు మీరు మొదటిసారి ఉపయోగించినప్పటి నుండి ఈ నిబంధనలు ప్రయోజనవంతంగా ఉంటాయి మరియు ముగించబడే వరకు ప్రయోజనవంతంగా మిగిలి ఉంటాయి. సేవ మరియు కంటెంట్‌ను ఉపయోగించுவதை మానివేయడం ద్వారా మీరు ఏవైనా కారణంతో ఈ నిబంధనలను ఎప్పుడైనా ముగించலாமు. ఏవైనా కారణంతో మేము ముందు నోటీసు ఇచ్చి ఈ నిబంధనలను ముగించலாமు. మీరు విభాగం 2 (ఉపయోగ అవసరాలు), విభాగం 5 (రహస్యత, భద్రత మరియు డేటా రక్షణ), విభాగం 8 (వివాద పరిష్కారం) లేదా విభాగం 9 (సాధారణ నిబంధనలు) లో మ aterial ప్రచండమైన ఉల్లంఘన చేస్తే, లేదా మా నియంత్రణలు మించిన మూడవ పార్టీ టెక్నాలజీ ప్రოვైడర్‌తో మా సంబంధం మారినట్లయితే, లేదా చట్టం లేదా ప్రభుత్వ అభ్యర్థనలకు అనుగుణంగా ఉంటే, మేము మీకు నోటిఫై చేస్తే ఈ నిబంధనలను వెంటనే ముగించலாமు. మీరు ఈ నిబంధనలకు అనుగుణంగా ప్రవర్తించకపోతే, లేదా మీ ఉపయోగం మాకు లేదా ఏదైనా మూడవ పార్టీకి భద్రత అప్రమత్తిని కలిగిస్తే, లేదా మీ ఉపయోగం మోసపూరితమని లేదా మాకు లేదా ఏదైనా మూడవ పార్టీకి బాధ్యతను కలిగిస్తుందని మేము సంశయించినట్లయితే, మేము సేవాకు మీ ప్రాప్యతను సస్పెండ్ చేయலாமు.',
    block19:
      'ముగింపు యొక్క ప్రభావాలు. ముగింపు అయినప్పుడు, మీరు సేవను ఉపయోగించడం ఆపివేసి, మమ్మ általా నిర్దేశించినట్లుగా ఏదైనా గోప్య సమాచారాన్ని వెంటనే తిరిగి ఇవ్వ거나 నాశనం చేయాలి. స్వభావంగా ముగింపు లేదా వ్యవధి పూర్తి అయిన తర్వాత కూడా కొనసాగించాల్సిన ఈ ప్రvisionsలు, ముఖ్యంగా విభాగం 3 మరియు 5-9 మ mukaan, కొనసాగించబడతాయి.',
    block2:
      'ఈ ఉపయోగ వ شرایطు నోమ్ సేవల మీ ఉపయోగానికి వర్తిస్తాయి, ఇందులో మా అనువర్తన ప్రోగ్రామింగ్ ఇంటర్‌ఫేస్‌లు, సాఫ్ట్‌వేర్, సాధనాలు, డెవలపర్ సేవలు, డేటా, డాక్యుమెంటేషన్ మరియు వెబ్‌సైట్ (సమూహంగా "సేవలు" అని పిలువబడతాయి) ఉన్నాయి. మా సేవలను ఉపయోగించడం ద్వారా, మీరు ఈ నిబంధనలకు పాటు చేయాలని ஒಪ్పుకొంటారు. మా గోప్యతా విధానం మేము వ్యక్తిగత సమాచారాన్ని ఎలా సేకరిస్తాము మరియు ఉపయోగిస్తాము అని వివరిస్తుంది.',
    block20:
      'సంరక్షణ. సేవાનు మీరు ఉపయోగించியது, మీ కంటెంట్, సేవతో సంబంధించిన ఉత్పత్తులు లేదా సేవలను మీరు ఉపయోగించியது మరియు ఈ నిబంధనలు లేదా ப్రయోగమయ చట్టాలను మీరు ఉల్లంఘించியதు వంటి విషయాల నుండి లేదా వాటికి సంబంధించి ఏదైనా దావలాపများ, నష్టాలు మరియు ఖర్చులు (వకీల వేతనాలను చేర్చి) నుండి మమ్మల్ను, మమ్మలి సంబంధిత సంస్థలను మరియు మమ్మలి ప్రజలను రక్షించడం, సంరక్షించడం మరియు హాని నుండి సురక్షितం చేస్తారు.',
    block21:
      '(బి) విస్మరణలు. సేవ వAILABLE "అస్ ఇస్" గా வழங்கப்படుతుంది. కანునం అనుమతించిన పరిధిలో, మేము మరియు మా సంబంధిత సంస్థలు మరియు లైసెన్సర్‌లు సేవ గురించి ఏ విధమైన ప్రాతినిధ్యాలు లేదా వారంటీలు ఇవ్వరు మరియు వారంటీలు ఇవ్వరు కూడా లేదు, వీటిలో వాణిజ్య స్వభావం, ప్రత్యేక ప్రయోజనం కోసం సరిపడటం, సంతృప్తికరమైన నాణ్యత, అINFRINGEMENT్ లేని స్వభావం, మరియు శాంతమైన ఆనందం వంటి వారంటీలు ఉన్నాయి మరియు వ్యాపార పరిచర్య లేదా వినియోగం వల్ల ఉత్పన్నమయ్యే ఏ వారంటీలు ఉన్నాయి. సేవ అంతరాయం లేకుండా, ఖచ్చితమైన లేదా లోపం లేనిది అనే వారంటీ మేము ఇవ్వరు లేదు లేదా ఏ కంటెంట్ భద్రతరంగా ఉంటుంది, కోల్పడదు లేదా మార్చబడదు అనే వారంటీ మేము ఇవ్వరు లేదు.',
    block22:
      '(c) బాధ్యత పరిమితి. మేము, మా సంబంధిత సంస్థలు లేదా మా లైసెన్సర్‌లు ఏ విచిత్రమైన, అకస్మాత్తున్న, ప్రత్యేకమైన, పర్యవసాన మాత్రమే లేదా శిక్షాత్మక నష్టాలకు బాధ్యత వహించరు, ఇందులో లాభ నష్టం, ప్రసిద్ధి నష్టం, ఉపయోగ నష్టం, డేటా నష్టం లేదా ఇతర మాంసిక నష్టాలు ఉన్నాయి, అయినప్పటికీ మాకు ఇటువంటి నష్టాల సంభావన గురించి సలహా ఇవ్వబడినప్పటికీ. ఈ నిబంధనల ప్రకారం, మా మొత్తం బాధ్యత వాదం ముందు ప్రధానం అయిన పన్నెండు (12) నెలలలో మీరు సేవికి చెల్లించిన ఫీజ్‌లు లేదా వంద యుఎస్ డాలర్లు ($100) వాటిలో పెద్దదానికి మించదు. ఈ విభాగంలోని పరిమితులు వర్తింపు చేయగల కાયక చట్టం ద్వారా అనుమతించిన గరిష్ట స్థాయికి వర్తిస్తాయి.',
    block23:
      'వ్యవహార నిబంధనలు మరియు సేవలను మీరు ఉపయోగించడం యుణైటెడ్ స్టేట్స్ యొక్క చట్టాల ద్వారా పరిపాలించబడుతుంది, 미국 చట్ట విభేద నియమాలు మినహా. అనువర్తనాన్ని మీరు ఉపయోగించడం ఇతర స్థానిక, రాష్ట్ర, జాతీయ లేదా అంతర్జాతీయ చట్టాలకు కూడా లోబడి ఉంటుంది. ఈ నిబంధనలతో సంబంధించిన ఏదైనా చట్టపర చర్య లేదా ప్రయత్నం యుణైటెడ్ స్టేట్స్ యొక్క న్యాయస్థానాలలో మాత్రమే తీసుకోబడుతుంది మరియు మీరు అటువంటి న్యాయస్థానాల యొక్క వ్యక్తిగత అధికారానికి లొంగి ప్రవేశించడానికి ஒப்பుకుంటారు.',
    block24:
      'పార్టీల మధ్య సంబంధం. నోమ్ మరియు మీరు స్వతంత్ర కాంట్రాక్టర్లు, మరియు ఇతర పార్టీ యొక్క ముందస్తు రచనాత్మక సలహా లేకుండా ఏ పార్టీயுமు ఇతర పార్టీని సూచించే లేదా బంధించే లేదా ఇతర పార్టీ కోసం బాధ్యతలను స్వీకరించే సామర్థ్యాన్ని కలిగి ఉండదు.',
    block25:
      'బ్రాండ్ ఉపయోగం. మా ముందు వ్రాతలంగా అనుమతి లేకుండా మీరు నోమ్ లేదా దాని ఏదైనా సంబంధಿತ సంస్థల పేరు, లోగోలు లేదా ట్రేడ్‌మార్క్‌లను ఉపయోగించలేరు.',
    block26:
      'ఈ నిబంధనలలోని ఏదైనా ప్రvisions్ చెల్లనిది, చట్టవిరుద్ధ లేదా అమలు చేయలేనిదిగా నిర్ణయించబడినట్లయితే, మిగిలిన ప్రvisions్ పూర్తి శక్తిలో మరియు ప్రభావంతో నిలిచిపోయాయి.',
    block3:
      'మీరు 18 సంవత్సరాల వయస్సు కంటే తక్కువ వయస్సు ఉన్నట్లయితే, సేవను ఉపయోగించడానికి మీ తల్లిదండ్రులు లేదా చట్టపరమైన సంరక్షకుల నుండి అనుమతి పొందాలి. మీరు మరొక వ్యక్తి లేదా సంస్థ వైపు నుండి సేవను ఉపయోగిస్తున్నట్లయితే, వారి ప్రాతినిధ్యం వద్ద ఈ ప్రచാരాలను అంగీకరించడానికి మీకు అధికారం ఉండాలి. ఖాతాను నమోదు చేయడానికి మీరు ఖచ్చితమైన మరియు పూర్తి సమాచారాన్ని అందించాలి. మీరు మీ సంస్థ వెలుపల ఉన్న ఎవరికైనా మీ యాక్సెస్ క్రెడెన్షియల్స్ లేదా ఖాతాను అందించ서는 కాదు, మరియు మీ క్రెడెన్షియల్స్ ఉపయోగించి జరిగే అన్ని కార్యకలాపాలకు మీరు బాధ్యత వహిస్తారు.',
    block4:
      '(ఎ) సేవेचు వాడకం. మీరు ఈ ప్రవచనాల ప్రకారం సేవను ప్రాప्त કરலாம், మరియు మేము మీకు సేవను ఉపయోగించే మాత్రమే ప్రాధికారం ఇస్తాము. సేవను ఉపయోగిస్తున్నప్పుడు, మీరు ఈ ప్రవచనాలు మరియు అన్ని ಅನువైన చట్టాలను పాటిస్తారు. మేము మరియు మా సంబంధిత సంస్థలు సేవలో అన్ని హక్కులు, శీర్షికలు మరియు ఆస్తులను కలిగి ఉన్నాము.',
    block5:
      'ఫీడ్‌బ్యాక్. మేము ఫీడ్‌బ్యాక్, వ్యాఖ్యలు, ఆలోచనలు, సూచనలు మరియు సుధారణలను స్వాగతం చేస్తాము. మీరు ఇటువంటి ఏదైనా కంటెంట్‌ను అందిస్తే, మేము దానిని ఎటువంటి పరిమితులు లేకుండా మరియు మీకు కompెన్సేషన్ లేకుండా ఉపయోగించலாமు.',
    block6:
      '(c) పరిమితులు. మీరు కాదు: (1) సేవను ఎవరి హక్కులను ఉల్లంఘిస్తుంది, మిక్సప్రొప్రియేట్ చేస్తుంది లేదా వలల్లుతుంది এমন పద్ధతిలో ఉపయోగించవద్దు; (2) రివర్స్ ఇంజినీర్, డీకాంపైల్, డిస్‌అసెంబుల్, అనువదించడం లేదా సేవ మోడల్స్, అల్గోరిథమ్‌లు మరియు సిస్టమ్‌ల యొక్క సోర్స్ కోడ్ లేదా అంతర్లీన భాగాలను కనుగొనడానికి ప్రయత్నించవద్దు (అప్లికబుల్ చట్టం ద్వారా આવి పరిమితులు నిషिद్ధం చేయబడలేదా తప్ప); (3) నోమ్‌తో పోటీ చేసే మోడల్‌లను అభివృద్ధి చేయడానికి సేవ యొక్క అవుట్‌పుట్‌ను ఉపయోగించవద్దు; (4) API ద్వారా అనుమతించబడినట్లు తప్ప, స్క్రేపింగ్, వెబ్ హార్వెస్టింగ్ లేదా వెబ్ డేటా ఎక్స్‌ట్రాక్షన్‌తో సహా ఏదైనా ఆటోమేటెడ్ లేదా ప్రోగ్రామింగ్ పద్ధతులను ఉపయోగించి సేవ నుండి డేటా లేదా అవుట్‌పుట్‌ను ఎక్స్‌ట్రాక్ట్ చేయవద్దు; (5) సేవ యొక్క అవుట్‌పుట్‌ను అసలు కానప్పుడు కृत్రిమంగా వెలువడినట్లు ప్రదర్శించవద్దు లేదా మా ఉపయోగ నীতులను లేదా వలల్లుతుంది; (6) మా ముందు సిఫార్సత ছাড়া API కీలను కొనుగోలు చేయవద్దు, విక్రయించవద్దు లేదా బదిలీ చేయవద్దు; లేదా (7) 13 సంవత్సరాల కంటే తక్కువ వయస్సు గల పిల్లల లేదా డిజిటల్ సంఘతి యొక్క అప్లికబుల్ వయస్సు యొక్క ఏదైనా వ్యక్తిగత సమాచారాన్ని మాకు అందించవద్దు. మీరు మా డాక్యుమెంటేషన్‌లోని ఏదైనా రేట్ లిమిట్‌లు మరియు ఇతర అవసరాలను పాటిస్తారు.',
    block7:
      '(డి) తృతీయ పార్టీ సేవలు. సేవతో సంబంధం ఉన్న ఏదైనా తృతీయ పార్టీ సాఫ్ట్‌వేర్, సేవలు లేదా ఇతర ఉత్పత్తులు వాటి స్వంత నిబంధనల ద్వారా పరిపాలించబడతాయి మరియు తృతీయ పార్టీ ఉత్పత్తులకు మేము బాధ్యత వహించముచు.',
    block8:
      'మీ కంటెంట్. మీరు సేవికి ఇన్పుట్ ("ఇన్పుట్") ను అందించலாமు మరియు ఇన్పుట్ ఆధారంగా ఉత్పత్తి చేయబడిన మరియు తిరిగి ఇచ్చిన అవుట్పుట్ ("అవుట్పుట్") ను పొందலாமు (సమూహంగా "కంటెంట్" అని సూచించబడుతుంది). పార్టీల మధ్య, మరియు వర్తించే చట్టాలు అనుమతించే పరిధిలో, మీరు అన్ని ఇన్పుట్‌లను స్వాధీనం చేసుకుంటారు. సేవను అందించడానికి మరియు నిర్వహించడానికి, వర్తించే చట్టాలను అనుసరించడానికి మరియు మా పాలసీలను అమలు చేయడానికి నోమ్ కంటెంట్‌ను ఉపయోగించலாமు. మీరు కంటెంట్ కు బాధ్యత వహిస్తారు, వర్తించే చట్టాలు లేదా ఈ నిబంధనలను ఉల్లంఘించకుండా ఉండటాన్ని సాధించడం సహా.',
    block9:
      'సమయతత్త్వం. కృత్రిమ మేధస్సు మరియు మెషిన్ లెర్నింగ్ వేగంగా అభివృద్ధి చెందుతున్న పరిశోధనా రంగాలు. మా సేవను మరింత ఖచ్చితమైన, నమ్మదగిన, సురక్షితమైన మరియు ప్రయోజనకరంగా మార్చడానికి మేము నిరంతరం ప్రయత్నిస్తున్నాము. మెషిన్ లెర్నింగ్ యొక్క సంభావ్యత స్వభావం కారణంగా, మా సేవను ఉపయోగించడం కొన్ని సందర్భాలలో తప్పు అవుట్‌పుట్‌లను ఉత్పత్తి చేస్తుంది, ఇవి నిజమైన వ్యక్తులు, ప్రదేశాలు లేదా వాస్తవాలు సరిగ్గా ప్రతిబింబించకపోవచ్చు. మీ ఉపయోగ సందర్భం ఆధారంగా ఏదైనా అవుట్‌పుట్ యొక్క ఖచ్చితత్వాన్ని మీరు సరిగ్గా అంచనా వేయాలి, ఇందులో మానవద్వారా అవుట్‌పుట్‌లను సమీక్షించడం వంటుంది.',
    subTitle1: 'రిజిస్ట్రేషన్ మరియు ప్రాప్యత',
    subTitle10: 'విడివిడిపరచitability',
    subTitle2: 'వాడకం అవసరాలు',
    subTitle3: 'కంటెంట్',
    subTitle4: 'ఫీజ్ మరియు పేమెంట్',
    subTitle5: 'గోప్యతा, భద్రత మరియు డేటా రక్షణ',
    subTitle6: 'మেয়াసు మరియు ముగింపు',
    subTitle7: 'సమాధానం; తిరస్కారాలు; బాధ్యత పరిమితి',
    subTitle8: 'శాసన చట్టం మరియు δικαιοδοషణ',
    subTitle9: 'సాధారణ నిబంధనలు',
    title: 'సేవా నిబంధనలు',
    updateTime: 'నవీకరించబడింది: మార్చి 15, 2024',
  },
  trialModal: {
    btn: 'ఇప్పుడే ప్రారంభించండి (మాత్రమే $0.99)',
    chat: 'చాట్‌పిడిఎఫ్',
    desc1: 'మీ ట్రయిల్ పూర్తి થયిన తర్వాత, మీకు వార్షిక ముద్ర విలువ $180 చార్జ్ చేయబడుతుంది',
    desc2: 'యాని ఏ సమయంలోనైనా రద్దు చేయవచ్చు',
    focus: 'కేంద్రీకరణ',
    hover: 'హోవర్ అనువాదం',
    image: 'ఇమేజ్ అనువాదం',
    installBtn: 'ఇప్పుడే ఇన్‌స్టాల్ చేసి మీ బహుమతిని పొందండి',
    memo: 'ప్రియమైనవి నిర్వహణ',
    pdf: 'PDF సమాంతర అనువాదం',
    realtime: 'తక్షణ అనువాదం',
    select: 'శబ్ద ఎంపిక అనువాదం',
    title: 'స్వాగత ప్రదానం',
    trialText: '7-రోజుల ప్రయోగం',
    video: 'వీడియో అనువాదం',
    videoSummary: 'వీడియో సమరీశన',
    web: 'పారలెల్ అనువాదం',
    webSummary: 'వెబ్ సారాంశం',
  },
  upgradeModal: {
    btn: 'ఇప్పుడే అప్‌గ్రేడ్ చేయండి',
    chat: {
      free: 'మీరు ChatPDF పరిమితిని చేరుకున్నారు',
      pro: 'ఈ నెలకు ChatPDF పరిమితి మీరు చేరుకున్నారు',
    },
    contactStr: 'తదుపరి రీసెట్‌కు వేచి ఉండండి లేదా contact@noam.tools వద్ద మమ్మల్ని సంప్రదించండి.',
    limitAlertStr: 'మీ ఉచిత ప్లాన్ పరిమితి చేర ਗਈ ਹੈ। కొనసాగించడానికి అప్‌గ్రేడ్ చేయండి.',
    more: 'ప్లాన్‌లను చూడండి',
    pageLimit: { free: 'మీరు PDF పేజీ పరిమితిని చేరుకున్నారు' },
    title: 'గుర్తు',
    upgradeAlertStr: 'మీ ఫ్రీ ప్లాన్ పరిమితి చేరుకున్నారు. కొనసాగించడానికి అప్‌గ్రేడ్ చేయండి.',
    upload: {
      free: 'మీరు మీ PDF అనువాద పరిమితిని చేరుకున్నారు',
      pro: 'ఈ మాసిక కు మీ PDF అనువాద పరిమితి చేరుకుంది',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'ఇప్పుడే చేరండి',
      label: 'కొత్త వినియోగదారుల ప్రయోజనాలు:',
      remain: 'మాత్రమే 30 మిగిలి ఉన్నాయి',
      text: 'మాత్రమే 100 స్పాట్లు అందుబాటులో ఉన్నాయి! ఇప్పుడే మీదాన్ని పట్టుకోండి!',
    },
  },
  aiPdfTranslator: {
    title: 'ఫ్రీ AI పిడిఎఫ్ ట్రాన్స్లేటర్: ఏదైనా భాషలలో పోలికతో పిడిఎఫ్ ಅನు అనువదించండి',
    desc: 'AI ద్వారా PDF ఫైళ్ళను ఏ languesకు అయినా సులభంగా అనువదించండి. అసలు మరియు అనువదించిన పాఠ్యాన్ని పక్షపక్షంగా పోల్చండి, వేగంగా మరియు ఉచితంగా.',
    keywords: 'జీపీటీ-4, ఏఐ అసిస్టెంట్, అనువాదం, సారాంశం, ఫోకస్, చాట్‌పిడిఎఫ్, మెమో, సామర్థ్యం',
    sourceToTarget: {
      title: 'ఫ్రీ PDF ట్రాన్స్లేషన్ టూల్: {{source}} ను {{target}} కు ఉచితంగా అనువదించండి',
      desc: 'ఈ సేవతో మీ PDF ఫైల్‌లను ఏదైనా మూల భాష నుండి మీ ఇష్ట భాషకు ఉచితంగా అనువదించండి. అడ్వాన్స్‌ਡ AI ద్వారా శక్తివంతమైన వేగవంతమైన, ఖచ్చితమైన మరియు సురక్షితమైన PDF అనువాదం.',
    },
    headerIntroduce: {
      title: 'నోమ్: కేవలం ఆన్‌లైన్ అనువాదం కంటే ఎక్కువ',
      introduce1: {
        title: 'నోమ్ · పిడిఎఫ్ రీడర్',
        desc: '✨సైడ్-బై-సైడ్ అనువాదం + AI ప్రశ్న-సమాధానం. పిడిఎఫ్‌లను మీ లక్ష్య భాషలోకి వేగంగా మరియు ఖచ్చితంగా అనువదించండి. మీ పిడిఎఫ్ ఫైల్‌ల గురించి లోతైన అవగాహన పొందడం కోసం కంటెంట్ గురించి స్వేచ్ఛగా ప్రశ్నలు అడగండి.',
      },
      introduce2: {
        title: 'నోమ్ · సైడ్-బై-సైడ్ ట్రాన్స్‌లేషన్ ఎక్స్‌టెన్షన్',
        desc: '👏మీ వెబ్‌పేజీ అనువాద అవసరాలన్నీ పరిష్కరించండి:',
        detail1: { title: 'వెబ్‌పేజీ అనువాదం:', desc: 'పక్షం-పక్షం ద్విజన భాషా వీక్షణం' },
        detail2: { title: 'పదం అనువాదం:', desc: 'ఒక క్లిక్‌తో వేగవంతమైన అనువాదం' },
        detail3: { title: 'తక్షణ అనువాదం:', desc: 'పదాలు లేదా వాక్యాలను వెంటనే అనువదించండి.' },
        detail4: { title: 'ఇమేజ్ అనువాదం:', desc: 'బildeలను అనువదించినది తో భర్తీ చేయండి.' },
        detail5: { title: 'వీడియో అనువాదం:', desc: 'మెరుగైన వీక్షణ కోసం బిలింగ్వల్ సబ్‌టైటిల్స్.' },
        footer: 'స్మార్ట్ అనువాదం కోసం మరిన్ని AI-సమర్థిత రీడింగ్ ఫీచర్‌లను అనుభవించండి!',
      },
    },
    subtitle: 'ఇన్‌లైన్‌లో పిడిఎఫ్ అనువదించడం ఉచితంగా',
    introduce: {
      module1: {
        detail1: {
          title: 'రియల్-టైమ్ సైడ్-బై-సైడ్ పిడిఎఫ్ అనువాదం',
          desc1:
            'అసమయంగా అసలు మరియు అనువదించిన కంటెంట్‌ను సింక్రోనైజ్డ్ మార్గంలో, పక్షం-పక్షం లేယเอაუთ్‌లో ప్రదర్శించండి',
          desc2: 'సింక్రোনైజ్డ్ స్క్రోలింగ్‌తో రెండు వెర్షన్లను సులభంగా పోల్చండి',
          desc3: 'సమానమైన ప్రదర్శన ఫార్మాట్‌ను సంరక్షించ하여 స్థిరమైన రీడింగ్ అనుభవాన్ని అందించడం',
        },
        detail2: {
          title: 'తక్షణమైన కంటెంట్ అలైన్‌మెంట్ మరియు వెరిఫికేషన్',
          desc1: 'సులభమైన వేధన కోసం మూల మరియు అనువదित పాఠ్యం మధ్య సంపూర్ణ సమలేఖనం',
          desc2: 'రెండు సంస్కరణలలో కంటెంట్ యొక్క ప్రతి విభాగం ఖచ్చితంగా సరిపోతుంది',
          desc3: 'విశ్వసనీయ ఫలితాల కోసం అనువాద విరుద్ధతలను త్వరగా గుర్తించి పరిష్కరించండి',
        },
      },
      module2: {
        detail1: {
          title: 'ఖచ్చితమైన అనువాదం కోసం మల్టిపుల్ అడ్వాన్స్డ్ ఏఐ మోడల్‌లు',
          desc1: 'మీ అనువాద అవసరాలను பொருத்துவதற்கு ప్రధాన AI మోడళ్‌ల నుండి ఎంచుకోండి',
          desc2: 'వివిధ ప్రलेख రకాలు మరియు పరిశ్రమల కోసం సరైన ఫలితాలను సాధించడం',
          desc3:
            'సౌకర్యవంతమైన మోడల్ ఎంపికలు ప్రతి సందర్భానికి కస్టమైజ్ చేయబడిన పరిష్కారాలను అందిస్తాయి',
        },
        detail2: {
          title: 'ప్రతి కంటెంట్ రకమ ਲਈ అడ్వాన్స్డ్ ఏఐ ట్రాన్స్‌లేషన్',
          desc1: 'మా శక్తివంతమైన AI మోడల్ అధిక ఖచ్చితత్వం మరియు సహజ భాషా అర్థాన్ని నిర్ధారిస్తుంది',
          desc2: 'తాంత్రిక, అకాడემిక్ మరియు సృజనాత్మక పత్రాలతో సులభంగా వ్యవహరిస్తుంది',
          desc3: 'మీ అన్ని అనువాద అవసరాలకు నమ్మదగిన ఫలితాలను అందిస్తుంది',
          desc4: 'అత్యుత్తమ ప్రదర్శన కోసం వివిధ కంటెంట్ రకాలకు తెలివైన అనుగుణన',
        },
      },
      module3: {
        detail1: {
          title: 'ఉత్సాహవంతమైన పత్రం ఇంటరాక్షన్',
          desc1:
            'అడ్వాన్స్‌డ్ ఏఐని ఉపయోగించి మీ పిడిఎఫ్ మరియు ప్రెజెంటేషన్ ఫైళ్‌లతో సులభంగా చాట్ చేయండి',
          desc2:
            'డాక్యుమెంట్ కంటెంట్ గురించి తక్షణమే ప్రశ్నలు అడగండి మరియు ఖచ్చితమైన సమాధానాలు పొందండి',
          desc3: 'దీర్ఘ పత్రాలకు త్వరగా సంక్షిప్త సారాంశాలను తయారు చేయండి',
        },
        detail2: {
          title: 'డీప్ కంటెంట్ విశ్లేషణ మరియు సీమ్‌లెస్ ఇంటిగ్రేషన్',
          desc1:
            'AI-సమర్థిత అర్థంతో ముఖ్య సమాచారాన్ని ఎక్స్‌ట్రాక్ట్ చేయండి మరియు సంక్లిష్ట డేటాని విశ్లేషించండి',
          desc2: 'తకనిక적, అకాడემిక్ లేదా సృజనాత్మక పదార్థాల గురించి అంతర్దృష్టులు పొందండి',
          desc3:
            'పూర్తి ప్రलेख నిర్వహణ పరిష్కారం కోసం మా PDF ట్రాన్స్లేటర్‌తో సున్నితంగా ఇంటిగ్రేట్ అవుతుంది',
        },
      },
      module4: {
        detail1: {
          title: 'PDF అనువాదం కంటే మించినది: అన్ని వస్తువులు కలిపి వెబ్‌పేజీ అనువాదం పరిష్కారం',
          desc: 'ప్రతి ఆన్‌లైన్ రీడింగ్ స్కెనేరియో కోసం రూపొందించిన మా శక్తివంతమైన సైడ్-బై-సైడ్ ట్రాన్స్‌లేషన్ ఎక్స్టెన్షన్‌ను కనుగొనండి.',
          desc1:
            'వెబ్‌పేజీ అనువాదం: సింక్రোনైజ్డ్ సైడ్-బై-సైడ్ వ్యూతో ద్విజęzyక కంటెంట్‌ను ఆస్వాదించండి',
          desc2: 'పదం అనువాదం: హైలైట్ చేయబడిన పదాలను సింగిల్ క్లిక్‌తో తక్షణంగా అనువదించండి',
          desc3:
            'తక్షణ అనువాదం: వేగవంతమైన అర్ధం కోసం ప్రస్తుత స్థితిలో ఏదైనా టెక్స్ట్ లేదా వాక్యాన్ని అనువదించండి',
          desc4:
            'ఇమేజ్ ట్రాన్స్‌లేషన్: అసలు ఇమేజ్‌లను స్వయంచాలకంగా అనువదించిన వెర్షన్‌లతో భర్తీ చేయండి',
          desc5: 'వీడియో అనువాదం: మెరుగైన అనుభవానికి ద్వభాషా సబ్‌టైటిల్‌లతో వీడియోలు చూడండి',
        },
      },
    },
    question: {
      title: 'తరచుగా అడిగే ప్రశ్నలు',
      answer1: {
        title: 'నోమ్ పిడిఎఫ్ ట్రాన్స్లేటర్ పిడిఎఫ్ అనువాదం కోసం ఉచితంగా ఉపయోగించవచ్చా?',
        content:
          'అవును, మీరు సైడర్ పిడిఎఫ్ ట్రాన్స్‌లేటర్‌తో పిడిఎఫ్‌లను ఉచితంగా అనువదించலாமు! మేము 5,000 టోకెన్ల ఉచిత క్వోటాను అందిస్తాము, ఇది మార్కెట్‌లో సాధారణంగా కనిపించే చాలా మంది పిడిఎఫ్ పత్రాలను అనువదించడానికి సరిపోతుంది. మీకు పెద్ద ఫైల్‌లను అనువదించాల్సిన అవసరం లేదా అడ్వాన్స్‌డ్ ఫీచర్‌లను అవసరం ఉంటే, మీరు మరింత సామర్థ్యాల కోసం మా ప్రीमియం ప్లాన్‌లకు అప్‌గ్రేడ్ చేయాలని ఎంచుకోవచ్చు.',
      },
      answer2: {
        title: 'నోమ్ పిడిఎఫ్ ట్రాన్స్లేటర్ ఎంత ఖచ్చితమైనది?',
        content:
          'నోమ్ పిడిఎఫ్ ట్రాన్స్లేటర్ అడ్వాన్స్డ్ ఏఐ టెక్నాలజీని ఉపయోగించడం ద్వారా మరియు మీ ప్రलेखాల కాంటెక్స్ట్‌ను లోతుగా అర్థం చేసుకోవడం ద్వారా అధిక స్థాయి ఖచ్చితమైన అనువాదాలను అందిస్తుంది. ఆటోమేటెడ్ అనువాదం పూర్తిగా సంభద్ధం కానప్పటికీ, మా సైడ్-బై-సైడ్ డిస్ప్లే మీకు ప్రతి అనువాదాన్ని సులభంగా సమీక్షించడానికి మరియు సవరించడానికి అనుమతిస్తుంది, చివరి ఫలితం మీ నాణ్యత సంభావనలను సంతృప్తిపరుస్తుంది. నోమ్‌తో విశ్వసనీయమైన మరియు ఖచ్చితమైన పిడిఎఫ్ అనువాదాన్ని అనుభవించండి.',
      },
      answer3: {
        title: 'స్కాన్ చేసిన పిడిఎఫ్‌లను నేను అనువదించగలనా?',
        content:
          'అవును, మా బిల్ట్-ఇన్ OCR (ఆప్టికల్ క్యారెక్టర్ రికగ్నిషన్) టెక్నాలజీతో స్కాన్ చేయబడిన PDFsను మీరు అనువదించலாமు. మా సిస్టమ్ స్కాన్ చేయబడిన డాక్యుమెంట్లు మరియు ఇమేజ్-బేస్ PDFs నుండి టెక్స్ట్‌ను స్వయంచాలకంగా సేకరిస్తుంది, ఆపై కంటెంట్‌ను మీకు అనువదిస్తుంది. ఇది సవరించలేని లేదా ఇమేజ్-మాత్రమే ఉన్న PDFs కు కూడా ఖచ్చితంగా అనువదించగలదని నిర్ధారిస్తుంది.',
      },
      answer4: {
        title: 'అనువాదం ఎంత కాలం పడుతుంది?',
        content:
          'ఉద్వేగకరణ వేగవంతమైన మరియు సమర్థవంతంగా ఉంటుంది—చాలా ஆధారాలు వాటి పొడవు మరియు సంక్లిష్టత ఆధారంగా సెకన్లలో నుండి కొన్ని నిమిషాల మధ్య ప్రాసెస్ చేయబడతాయి. ఉదాహరణకు, స్టాండర్డ్ 10-పేజ్ PDFను అనువదించడానికి సాధారణంగా 2 నిమిషాల కంటే తక్కువ సమయం పడుతుంది. మీ అన్ని డాక్యుమెంట్ అనువదన అవసరాలకు వేగవంతమైన తిరిగి రావు సమయాలను ఆస్వాదించండి!',
      },
      answer5: {
        title: 'చదవడానికి సైడ్-బై-సైడ్ వ్యూను నేను ఉంచగలిగానా?',
        content:
          'అవును, మీరు ఎల్లప్పుడూ మీ పత్రాలను పక్కపక్కన పڑవచ్చেনు. ఈ లేఅవుట్ మీకు మూల మరియు అనువదিত కంటెంట్‌ను సులభంగా పోల్చడానికి అనుమతిస్తుంది, ఇది మృదువైన మరియు సమర్థవంతమైన ప్రచార అనుభవాన్ని హేతుబద్ధం చేస్తుంది.',
      },
    },
    freeTrial: 'ఫ్రీ ట్రయల్',
    toLanguage: { title: 'PDF AI అనువాద జతలు', item: '{{సోర్స్}} నుంచి {{టార్గెట్}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'బ్లాగ్',
      features: 'లక్షణాలు',
      pricing: 'ధర నిర্ধारणం',
      faq: 'తరచుగా అడిగే ప్రశ్నలు',
      button: 'ఇప్పుడు అనువదించు',
    },
    hero: {
      upload: {
        title: 'మీ PDF ను అప్‌లోడ్ చేయండి',
        max: 'మాక్స్',
        desc: 'లేదా డ్రాగ్ & డ్రాప్ చేయండి',
        highlight: 'బ్రౌజ్ చేయడానికి క్లిక్ చేయండి',
      },
      to: 'కు',
      pill: 'AI-సమర్థిత PDF అనువాదకం',
      title: 'ఫ్రీ పిడిఎఫ్ ట్రాన్స్లేటర్',
      model: 'GPT-4 & క్లాడ్',
      support: 'ఓసిఆర్ సపోర్ట్',
      desc: 'అసలు లేఅవుట్‌ను సంరక్షించే తక్షణ, ఖచ్చితమైన అనువాదాలు. నోమ్ AI OCR మరియు సైడ్-బై-సైడ్ వ్యూలను మద్దతు ఇస్తుంది.',
      free: 'ఫ్రీ ట్రయల్',
      complete: 'అనువాదం పూర్తయింది',
      translated: 'నోమ్ ద్వారా అనువదించబడింది',
    },
    ticker: {
      pdf: 'PDF అనువాదం',
      format: 'ఫార్మాట్ రిటెన్షన్',
      ocr: 'ఓసిఆర్ టెక్నాలజీ',
      multi: 'బహుభాషా',
      side: 'సైడ్-బై-సైడ్',
      chat: 'PDF తో చాట్ చేయండి',
      web: 'వెబ్ అనువాదం',
      secure: 'సురక్షితమైన & ప్రైవేట్',
    },
    comparison: {
      bad: {
        title: 'స్టాండర్డ్ ట్రాన్స్లేషన్',
        head: 'ఫార్మాటింగ్ మరియు కాంటెక్స్ట్ కోల్పోయildi',
        text1: 'ప్రదర్శనా తప్పు: లేఅవుట్ పగబట్టారు. చిత్రాలు తప్పుగా ఉంచబడ్డాయి.',
        text2:
          'టెక్స్ట్ ఓవర్లాప్ అవుతుంది మరియు ఫాంట్‌లు స్థిరంగా లేవు. చదవడం కష్టం మరియు ప్రొఫెషనల్ కాదు...',
      },
      dump: { title: 'ప్లైన్ టెక్స్ట్ డంప్' },
      good: {
        title: 'నోమ్ ఏఐ అనువాదం',
        tag: 'పర్ఫెక్ట్ ఫలితం',
        sub: 'సంపూర్ణ ఫార్మాటింగ్, సందర్భమును తెలుసుకునే',
      },
      title: 'నోమ్ AI ను ఎందుకు ఎంచుకోవాలి?',
      desc: 'కాపీ-పేస్ట్ అనువాదంతో సंघర్షించడం ఆపండి. ప్రామాణిక సాధనాలు మరియు మా AI-సమర్థిత కాంటెక్స్ట్-అవేర్ అనువాదం మధ్య తేడాను అనుభవించండి.',
    },
    showcase: {
      kicker: 'సమర్థిత పత్రాలు',
      title1: 'ఏదైనా పత్రం',
      title2: 'ఏదైనా భాష',
      carousel1: 'కళలు',
      carousel2: 'వాస్తుశిల్పం',
      carousel4: 'మెడిసిన్',
      carousel5: 'ఫైనాన్స్',
      carousel3: 'అకాడమిక్ జర్నల్',
      carousel6: 'కანాను',
      carousel7: 'కాంట్రాక్ట్',
      note: 'టెక్నికల్, అకాడమిక్ మరియు క్రియేటివ్ డాక్యుమెంట్‌లను సులభంగా నిర్వహించండి.',
      carousel8: 'పాలసీ',
    },
    features: {
      big: {
        title: 'అడ్వాన్స్‌డ్ ఏఐ మోడల్‌లు (GPT-4, క్లాడ్)',
        desc: 'మీ అనువాద అవసరాలను తగ్గించడానికి అగ్రగామి AI మోడెల్స్ నుండి ఎంచుకోండి. వివిధ డాక్యుమెంట్ రకాలకు సరైన ఫలితాలను నిర్ధారించండి.',
      },
      grid1: {
        title: 'ఓసిఆర్ సపోర్ట్',
        desc: 'స్కాన్ చేయబడిన పిడిఎఫ్‌లు మరియు చిత్రങ്ങള నుండి టెక్స్ట్‌ను వెంటనే ఎక్స్‌ట్రాక్ట్ చేసి అనువదించండి.',
      },
      grid2: {
        title: 'హై-రెస్ ఎగ్జపోర్ట్',
        desc: 'మूल లేယเอაუთ్‌తో PDF ఫార్మాట్‌లో మీ అనువదించిన ప్రलేఖలను డౌన్‌లోడ్ చేయండి.',
      },
      grid3: {
        title: 'సైడ్-బై-సైడ్ పోలిక',
        desc: 'అసలు మరియు అనువదించిన పాఠ్యాన్ని పోల్చడానికి సింక్రోణైజ్ స్క్రోలింగ్.',
      },
      title1: 'మాత్రమే అనువాదం కంటే ఎక్కువ',
      title2: 'ఇది ఒక విప్లవం',
      line1: 'టెక్నికల్ పేపర్.pdf',
      line2: 'భాషను గుర్తించడం: ఇంగ్లీష్...',
      line3: 'మోడల్: GPT-4o (హై ప్రెసిషన్)',
      line4: 'అనువాదం పూర్తయింది (99% ఖచ్చితత్వం)',
    },
    testimonials: {
      review1: {
        role: 'శాస్త్రవేత్త',
        content:
          'నోమ్ ఏఐ అకాడమిక్ పేపర్‌లను అనువదించడంలో నాకు గంటలు రక్షించింది. సైడ్-బై-సైడ్ వ్యూ ప్రయత్నిక పదాలను ప్రవీకరించడానికి చాలా ఉపయోగపడుతుంది.',
      },
      review2: {
        role: 'గ్లోబల్ మార్కెటర్',
        content:
          'నేను ఉపయోగించిన సেরా PDF అనువాదకుడు. ఇది అసలు ఫార్మాటింగ్‌ను ప్రదక్షిణంగా ప్రదర్శిస్తుంది, ఇది మా మార్కెటింగ్ డెక్క్‌లకు కీలకం. ',
      },
      review3: {
        role: 'కాన్సిల్టింగ్ చట్ట నిపుణుడు',
        content:
          'సચారమైన మరియు వేగవంతమైనది. నేను దీనిని కాంట్రాక్ట్ అనువాదాల కోసం ఉపయోగిస్తున్నాను మరియు స్కాన్ చేయబడిన డాక్యుమెంట్‌ల కోసం OCR ఫీచర్ సంభవమైనంత మెరుగ్గా పనిచేస్తుంది.',
      },
      kicker: 'వినియోగదారులచే ప్రేమించబడుతుంది',
      title: 'మా వినియోగదారులు ఏమి చెబుతారు',
    },
    cta: {
      title: 'భాషా అవరోధాలను పడప்பதకు సిద్ధంగా ఉన్నారా?',
      hint: '',
      button: 'ఉచితంగా అనువదనం ప్రారంభించండి',
      desc: 'ఇప్పుడే 10,000+ వినియోగదారులతో చేరండి మరియు నోమ్ ఏఐతో మీ పత్రాలను అనువదించడం ప్రారంభించండి.',
    },
    languagePairs: {
      title: 'ఇంగ్లీష్ పిడిఎఫ్ ఏఐ అనువాద జతలు',
      desc: 'నోమ్ AI ద్వారా మద్దతు ప्रदత్త ప్రచుర మொழிபெயர்ப்பు దిశలు',
    },
    footer: {
      about: 'మమ్మల్ని గురించి',
      privacy: 'ప్రైవసీ పాలసీ',
      contact: 'సపోర్ట్‌కు సంప్రదించండి',
    },
  },
}

export default TRANSLATION
